// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file web/public/credit.proto (package web.public, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { Error } from "./error_pb.js";
import { Alert } from "./alert_pb.js";
import { Address, Name } from "./credit_monitoring_pb.js";

/**
 * @generated from enum web.public.FactorType
 */
export enum FactorType {
  /**
   * @generated from enum value: CARD_USAGE = 0;
   */
  CARD_USAGE = 0,

  /**
   * @generated from enum value: PAYMENT_HISTORY = 1;
   */
  PAYMENT_HISTORY = 1,

  /**
   * @generated from enum value: CREDIT_MIX = 2;
   */
  CREDIT_MIX = 2,

  /**
   * @generated from enum value: DEROGATORY_MARKS = 3;
   */
  DEROGATORY_MARKS = 3,

  /**
   * @generated from enum value: CREDIT_AGE = 4;
   */
  CREDIT_AGE = 4,

  /**
   * @generated from enum value: HARD_INQUIRIES = 5;
   */
  HARD_INQUIRIES = 5,

  /**
   * @generated from enum value: CHARGE_OFF_AND_COLLECTIONS = 6;
   */
  CHARGE_OFF_AND_COLLECTIONS = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(FactorType)
proto3.util.setEnumType(FactorType, "web.public.FactorType", [
  { no: 0, name: "CARD_USAGE" },
  { no: 1, name: "PAYMENT_HISTORY" },
  { no: 2, name: "CREDIT_MIX" },
  { no: 3, name: "DEROGATORY_MARKS" },
  { no: 4, name: "CREDIT_AGE" },
  { no: 5, name: "HARD_INQUIRIES" },
  { no: 6, name: "CHARGE_OFF_AND_COLLECTIONS" },
]);

/**
 * @generated from enum web.public.CreditBureau
 */
export enum CreditBureau {
  /**
   * @generated from enum value: EQUIFAX = 0;
   */
  EQUIFAX = 0,

  /**
   * @generated from enum value: TRANSUNION = 1;
   */
  TRANSUNION = 1,

  /**
   * @generated from enum value: EXPERIAN = 2;
   */
  EXPERIAN = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(CreditBureau)
proto3.util.setEnumType(CreditBureau, "web.public.CreditBureau", [
  { no: 0, name: "EQUIFAX" },
  { no: 1, name: "TRANSUNION" },
  { no: 2, name: "EXPERIAN" },
]);

/**
 * @generated from message web.public.GetFactorHistoryRequest
 */
export class GetFactorHistoryRequest extends Message<GetFactorHistoryRequest> {
  /**
   * @generated from field: web.public.FactorType factor_type = 1;
   */
  factorType = FactorType.CARD_USAGE;

  constructor(data?: PartialMessage<GetFactorHistoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetFactorHistoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "factor_type", kind: "enum", T: proto3.getEnumType(FactorType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFactorHistoryRequest {
    return new GetFactorHistoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFactorHistoryRequest {
    return new GetFactorHistoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFactorHistoryRequest {
    return new GetFactorHistoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFactorHistoryRequest | PlainMessage<GetFactorHistoryRequest> | undefined, b: GetFactorHistoryRequest | PlainMessage<GetFactorHistoryRequest> | undefined): boolean {
    return proto3.util.equals(GetFactorHistoryRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetFactorHistoryResponse
 */
export class GetFactorHistoryResponse extends Message<GetFactorHistoryResponse> {
  /**
   * @generated from field: web.public.GetFactorHistoryResponse.Status status = 1;
   */
  status = GetFactorHistoryResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.GetFactorHistoryResponse.ValueHistory value_history = 3;
   */
  valueHistory?: GetFactorHistoryResponse.ValueHistory;

  constructor(data?: PartialMessage<GetFactorHistoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetFactorHistoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetFactorHistoryResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "value_history", kind: "message", T: GetFactorHistoryResponse.ValueHistory },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFactorHistoryResponse {
    return new GetFactorHistoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFactorHistoryResponse {
    return new GetFactorHistoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFactorHistoryResponse {
    return new GetFactorHistoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFactorHistoryResponse | PlainMessage<GetFactorHistoryResponse> | undefined, b: GetFactorHistoryResponse | PlainMessage<GetFactorHistoryResponse> | undefined): boolean {
    return proto3.util.equals(GetFactorHistoryResponse, a, b);
  }

  static _enums: {
    Status: typeof GetFactorHistoryResponse.Status,
  };
}

export namespace GetFactorHistoryResponse {
  /**
   * @generated from enum web.public.GetFactorHistoryResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetFactorHistoryResponse.Status)
  proto3.util.setEnumType(GetFactorHistoryResponse.Status, "web.public.GetFactorHistoryResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

export namespace GetFactorHistoryResponse {
  /**
   * @generated from message web.public.GetFactorHistoryResponse.FactorValue
   */
  export class FactorValue extends Message<GetFactorHistoryResponse.FactorValue> {
    /**
     * @generated from field: google.protobuf.Timestamp generated_at = 1;
     */
    generatedAt?: Timestamp;

    /**
     * @generated from field: uint32 value = 2;
     */
    value = 0;

    constructor(data?: PartialMessage<GetFactorHistoryResponse.FactorValue>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.GetFactorHistoryResponse.FactorValue";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "generated_at", kind: "message", T: Timestamp },
      { no: 2, name: "value", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFactorHistoryResponse.FactorValue {
      return new GetFactorHistoryResponse.FactorValue().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFactorHistoryResponse.FactorValue {
      return new GetFactorHistoryResponse.FactorValue().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFactorHistoryResponse.FactorValue {
      return new GetFactorHistoryResponse.FactorValue().fromJsonString(jsonString, options);
    }

    static equals(a: GetFactorHistoryResponse.FactorValue | PlainMessage<GetFactorHistoryResponse.FactorValue> | undefined, b: GetFactorHistoryResponse.FactorValue | PlainMessage<GetFactorHistoryResponse.FactorValue> | undefined): boolean {
      return proto3.util.equals(GetFactorHistoryResponse.FactorValue, a, b);
    }

    static _enums: {
    };
  }
}

export namespace GetFactorHistoryResponse {
  /**
   * @generated from message web.public.GetFactorHistoryResponse.ValueHistory
   */
  export class ValueHistory extends Message<GetFactorHistoryResponse.ValueHistory> {
    /**
     * @generated from field: repeated web.public.GetFactorHistoryResponse.FactorValue values = 1;
     */
    values: GetFactorHistoryResponse.FactorValue[] = [];

    /**
     * @generated from field: uint32 chart_lower_bound = 2;
     */
    chartLowerBound = 0;

    /**
     * @generated from field: uint32 chart_upper_bound = 3;
     */
    chartUpperBound = 0;

    /**
     * @generated from field: google.protobuf.Timestamp chart_start_date = 4;
     */
    chartStartDate?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp chart_end_date = 5;
     */
    chartEndDate?: Timestamp;

    constructor(data?: PartialMessage<GetFactorHistoryResponse.ValueHistory>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.GetFactorHistoryResponse.ValueHistory";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "values", kind: "message", T: GetFactorHistoryResponse.FactorValue, repeated: true },
      { no: 2, name: "chart_lower_bound", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 3, name: "chart_upper_bound", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 4, name: "chart_start_date", kind: "message", T: Timestamp },
      { no: 5, name: "chart_end_date", kind: "message", T: Timestamp },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFactorHistoryResponse.ValueHistory {
      return new GetFactorHistoryResponse.ValueHistory().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFactorHistoryResponse.ValueHistory {
      return new GetFactorHistoryResponse.ValueHistory().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFactorHistoryResponse.ValueHistory {
      return new GetFactorHistoryResponse.ValueHistory().fromJsonString(jsonString, options);
    }

    static equals(a: GetFactorHistoryResponse.ValueHistory | PlainMessage<GetFactorHistoryResponse.ValueHistory> | undefined, b: GetFactorHistoryResponse.ValueHistory | PlainMessage<GetFactorHistoryResponse.ValueHistory> | undefined): boolean {
      return proto3.util.equals(GetFactorHistoryResponse.ValueHistory, a, b);
    }

    static _enums: {
    };
  }
}

/**
 * @generated from message web.public.GetCreditPageNotificationRequest
 */
export class GetCreditPageNotificationRequest extends Message<GetCreditPageNotificationRequest> {
  constructor(data?: PartialMessage<GetCreditPageNotificationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetCreditPageNotificationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditPageNotificationRequest {
    return new GetCreditPageNotificationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditPageNotificationRequest {
    return new GetCreditPageNotificationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditPageNotificationRequest {
    return new GetCreditPageNotificationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditPageNotificationRequest | PlainMessage<GetCreditPageNotificationRequest> | undefined, b: GetCreditPageNotificationRequest | PlainMessage<GetCreditPageNotificationRequest> | undefined): boolean {
    return proto3.util.equals(GetCreditPageNotificationRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetCreditPageNotificationResponse
 */
export class GetCreditPageNotificationResponse extends Message<GetCreditPageNotificationResponse> {
  /**
   * @generated from field: web.public.GetCreditPageNotificationResponse.Status status = 1;
   */
  status = GetCreditPageNotificationResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.Alert notification = 3;
   */
  notification?: Alert;

  constructor(data?: PartialMessage<GetCreditPageNotificationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetCreditPageNotificationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetCreditPageNotificationResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "notification", kind: "message", T: Alert },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditPageNotificationResponse {
    return new GetCreditPageNotificationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditPageNotificationResponse {
    return new GetCreditPageNotificationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditPageNotificationResponse {
    return new GetCreditPageNotificationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditPageNotificationResponse | PlainMessage<GetCreditPageNotificationResponse> | undefined, b: GetCreditPageNotificationResponse | PlainMessage<GetCreditPageNotificationResponse> | undefined): boolean {
    return proto3.util.equals(GetCreditPageNotificationResponse, a, b);
  }

  static _enums: {
    Status: typeof GetCreditPageNotificationResponse.Status,
  };
}

export namespace GetCreditPageNotificationResponse {
  /**
   * @generated from enum web.public.GetCreditPageNotificationResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetCreditPageNotificationResponse.Status)
  proto3.util.setEnumType(GetCreditPageNotificationResponse.Status, "web.public.GetCreditPageNotificationResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.GetChatFactorChangesRequest
 */
export class GetChatFactorChangesRequest extends Message<GetChatFactorChangesRequest> {
  constructor(data?: PartialMessage<GetChatFactorChangesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetChatFactorChangesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetChatFactorChangesRequest {
    return new GetChatFactorChangesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetChatFactorChangesRequest {
    return new GetChatFactorChangesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetChatFactorChangesRequest {
    return new GetChatFactorChangesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetChatFactorChangesRequest | PlainMessage<GetChatFactorChangesRequest> | undefined, b: GetChatFactorChangesRequest | PlainMessage<GetChatFactorChangesRequest> | undefined): boolean {
    return proto3.util.equals(GetChatFactorChangesRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetChatFactorChangesResponse
 */
export class GetChatFactorChangesResponse extends Message<GetChatFactorChangesResponse> {
  /**
   * @generated from field: web.public.GetChatFactorChangesResponse.Status status = 1;
   */
  status = GetChatFactorChangesResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated web.public.ChatFactorChange factor_changes = 3;
   */
  factorChanges: ChatFactorChange[] = [];

  /**
   * @generated from field: string summary = 4;
   */
  summary = "";

  constructor(data?: PartialMessage<GetChatFactorChangesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetChatFactorChangesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetChatFactorChangesResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "factor_changes", kind: "message", T: ChatFactorChange, repeated: true },
    { no: 4, name: "summary", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetChatFactorChangesResponse {
    return new GetChatFactorChangesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetChatFactorChangesResponse {
    return new GetChatFactorChangesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetChatFactorChangesResponse {
    return new GetChatFactorChangesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetChatFactorChangesResponse | PlainMessage<GetChatFactorChangesResponse> | undefined, b: GetChatFactorChangesResponse | PlainMessage<GetChatFactorChangesResponse> | undefined): boolean {
    return proto3.util.equals(GetChatFactorChangesResponse, a, b);
  }

  static _enums: {
    Status: typeof GetChatFactorChangesResponse.Status,
  };
}

export namespace GetChatFactorChangesResponse {
  /**
   * @generated from enum web.public.GetChatFactorChangesResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetChatFactorChangesResponse.Status)
  proto3.util.setEnumType(GetChatFactorChangesResponse.Status, "web.public.GetChatFactorChangesResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.ChatFactorChange
 */
export class ChatFactorChange extends Message<ChatFactorChange> {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt = "";

  /**
   * @generated from field: string response = 2;
   */
  response = "";

  /**
   * @generated from field: double previous = 3;
   */
  previous = 0;

  /**
   * @generated from field: double current = 4;
   */
  current = 0;

  /**
   * @generated from field: repeated web.public.ChatFactorChange.AccountImpact account_impacts = 5;
   */
  accountImpacts: ChatFactorChange.AccountImpact[] = [];

  constructor(data?: PartialMessage<ChatFactorChange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ChatFactorChange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "response", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "previous", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "current", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "account_impacts", kind: "message", T: ChatFactorChange.AccountImpact, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChatFactorChange {
    return new ChatFactorChange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChatFactorChange {
    return new ChatFactorChange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChatFactorChange {
    return new ChatFactorChange().fromJsonString(jsonString, options);
  }

  static equals(a: ChatFactorChange | PlainMessage<ChatFactorChange> | undefined, b: ChatFactorChange | PlainMessage<ChatFactorChange> | undefined): boolean {
    return proto3.util.equals(ChatFactorChange, a, b);
  }

  static _enums: {
  };
}

export namespace ChatFactorChange {
  /**
   * @generated from message web.public.ChatFactorChange.AccountImpact
   */
  export class AccountImpact extends Message<ChatFactorChange.AccountImpact> {
    /**
     * id || account_number
     *
     * @generated from field: string account_id = 1;
     */
    accountId = "";

    /**
     * @generated from field: double impact = 2;
     */
    impact = 0;

    /**
     * @generated from field: string account_name = 3;
     */
    accountName = "";

    /**
     * @generated from field: google.protobuf.Timestamp generated_date = 5;
     */
    generatedDate?: Timestamp;

    /**
     * @generated from field: web.public.ChatFactorChange.AccountImpact.AccountType account_type = 6;
     */
    accountType = ChatFactorChange.AccountImpact.AccountType.UNKNOWN;

    /**
     * @generated from field: sint32 valence = 7;
     */
    valence = 0;

    constructor(data?: PartialMessage<ChatFactorChange.AccountImpact>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.ChatFactorChange.AccountImpact";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "impact", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
      { no: 3, name: "account_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 5, name: "generated_date", kind: "message", T: Timestamp },
      { no: 6, name: "account_type", kind: "enum", T: proto3.getEnumType(ChatFactorChange.AccountImpact.AccountType) },
      { no: 7, name: "valence", kind: "scalar", T: 17 /* ScalarType.SINT32 */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChatFactorChange.AccountImpact {
      return new ChatFactorChange.AccountImpact().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChatFactorChange.AccountImpact {
      return new ChatFactorChange.AccountImpact().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChatFactorChange.AccountImpact {
      return new ChatFactorChange.AccountImpact().fromJsonString(jsonString, options);
    }

    static equals(a: ChatFactorChange.AccountImpact | PlainMessage<ChatFactorChange.AccountImpact> | undefined, b: ChatFactorChange.AccountImpact | PlainMessage<ChatFactorChange.AccountImpact> | undefined): boolean {
      return proto3.util.equals(ChatFactorChange.AccountImpact, a, b);
    }

    static _enums: {
      AccountType: typeof ChatFactorChange.AccountImpact.AccountType,
    };
  }
}

export namespace ChatFactorChange.AccountImpact {
  /**
   * @generated from enum web.public.ChatFactorChange.AccountImpact.AccountType
   */
  export enum AccountType {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: INSTALLMENT = 1;
     */
    INSTALLMENT = 1,

    /**
     * @generated from enum value: REVOLVING = 2;
     */
    REVOLVING = 2,

    /**
     * @generated from enum value: MORTGAGE = 3;
     */
    MORTGAGE = 3,

    /**
     * @generated from enum value: OTHER = 4;
     */
    OTHER = 4,

    /**
     * @generated from enum value: INQUIRY = 5;
     */
    INQUIRY = 5,

    /**
     * @generated from enum value: COLLECTION = 6;
     */
    COLLECTION = 6,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ChatFactorChange.AccountImpact.AccountType)
  proto3.util.setEnumType(ChatFactorChange.AccountImpact.AccountType, "web.public.ChatFactorChange.AccountImpact.AccountType", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "INSTALLMENT" },
    { no: 2, name: "REVOLVING" },
    { no: 3, name: "MORTGAGE" },
    { no: 4, name: "OTHER" },
    { no: 5, name: "INQUIRY" },
    { no: 6, name: "COLLECTION" },
  ]);
}

/**
 * @generated from message web.public.GetCreditRequest
 */
export class GetCreditRequest extends Message<GetCreditRequest> {
  /**
   * Note: On or after this date
   *
   * @generated from field: google.protobuf.Timestamp generated_date = 1;
   */
  generatedDate?: Timestamp;

  constructor(data?: PartialMessage<GetCreditRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetCreditRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "generated_date", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditRequest {
    return new GetCreditRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditRequest {
    return new GetCreditRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditRequest {
    return new GetCreditRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditRequest | PlainMessage<GetCreditRequest> | undefined, b: GetCreditRequest | PlainMessage<GetCreditRequest> | undefined): boolean {
    return proto3.util.equals(GetCreditRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetCreditResponse
 */
export class GetCreditResponse extends Message<GetCreditResponse> {
  /**
   * @generated from field: web.public.GetCreditResponse.Status status = 1;
   */
  status = GetCreditResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.CreditV2 credit = 3;
   */
  credit?: CreditV2;

  /**
   * @generated from field: bool show_intro = 4 [deprecated = true];
   * @deprecated
   */
  showIntro = false;

  constructor(data?: PartialMessage<GetCreditResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetCreditResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetCreditResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "credit", kind: "message", T: CreditV2 },
    { no: 4, name: "show_intro", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditResponse {
    return new GetCreditResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditResponse {
    return new GetCreditResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditResponse {
    return new GetCreditResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditResponse | PlainMessage<GetCreditResponse> | undefined, b: GetCreditResponse | PlainMessage<GetCreditResponse> | undefined): boolean {
    return proto3.util.equals(GetCreditResponse, a, b);
  }

  static _enums: {
    Status: typeof GetCreditResponse.Status,
  };
}

export namespace GetCreditResponse {
  /**
   * @generated from enum web.public.GetCreditResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetCreditResponse.Status)
  proto3.util.setEnumType(GetCreditResponse.Status, "web.public.GetCreditResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.GetCreditTribureauRequest
 */
export class GetCreditTribureauRequest extends Message<GetCreditTribureauRequest> {
  /**
   * @generated from field: web.public.GetCreditTribureauRequest.Source source = 1;
   */
  source = GetCreditTribureauRequest.Source.UNKNOWN;

  constructor(data?: PartialMessage<GetCreditTribureauRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetCreditTribureauRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "source", kind: "enum", T: proto3.getEnumType(GetCreditTribureauRequest.Source) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditTribureauRequest {
    return new GetCreditTribureauRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditTribureauRequest {
    return new GetCreditTribureauRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditTribureauRequest {
    return new GetCreditTribureauRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditTribureauRequest | PlainMessage<GetCreditTribureauRequest> | undefined, b: GetCreditTribureauRequest | PlainMessage<GetCreditTribureauRequest> | undefined): boolean {
    return proto3.util.equals(GetCreditTribureauRequest, a, b);
  }

  static _enums: {
    Source: typeof GetCreditTribureauRequest.Source,
  };
}

export namespace GetCreditTribureauRequest {
  /**
   * https://www.notion.so/kikoff/Credit-Pulls-Source-of-Truth-13537806ebbd80269c7ac878ca2d471c
   * append the query param to the link above
   *
   * @generated from enum web.public.GetCreditTribureauRequest.Source
   */
  export enum Source {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * ?pvs=4#02660b31d7fc4597a21d2a89df036b8d
     *
     * @generated from enum value: EXPERIAN_TAB = 1;
     */
    EXPERIAN_TAB = 1,

    /**
     * ?pvs=4#02660b31d7fc4597a21d2a89df036b8d
     *
     * @generated from enum value: TRANSUNION_TAB = 2;
     */
    TRANSUNION_TAB = 2,

    /**
     * ?pvs=4#a33e54f309354f7cb9ec637233e5a0ff
     *
     * @generated from enum value: FULL_REPORT = 3;
     */
    FULL_REPORT = 3,

    /**
     * ?pvs=4#34f4336185604e419cd7d274098125d5
     *
     * @generated from enum value: TRIBUREAU_DISPUTE_PREMIUM_UPSELL = 4;
     */
    TRIBUREAU_DISPUTE_PREMIUM_UPSELL = 4,

    /**
     * ?pvs=4#13e37806ebbd80a9b594faba7e439a22 ?pvs=4#13e37806ebbd80608cdbf2ee2d125142
     *
     * @generated from enum value: TRIBUREAU_DISPUTE_REVIEW = 5;
     */
    TRIBUREAU_DISPUTE_REVIEW = 5,

    /**
     * DO NOT USE merged with TRIBUREAU_DISPUTE_REVIEW
     *
     * @generated from enum value: LIST_DISPUTE = 6;
     */
    LIST_DISPUTE = 6,

    /**
     * ?pvs=4#13537806ebbd80aaa56cf01de4cf5010
     *
     * @generated from enum value: DEBT_NEGOTIATION_PREMIUM_UPGRADE = 7;
     */
    DEBT_NEGOTIATION_PREMIUM_UPGRADE = 7,

    /**
     * ?pvs=4#17e37806ebbd80c09f69ef37ce7a4cf0
     *
     * @generated from enum value: SELECT_DISPUTE = 8;
     */
    SELECT_DISPUTE = 8,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetCreditTribureauRequest.Source)
  proto3.util.setEnumType(GetCreditTribureauRequest.Source, "web.public.GetCreditTribureauRequest.Source", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "EXPERIAN_TAB" },
    { no: 2, name: "TRANSUNION_TAB" },
    { no: 3, name: "FULL_REPORT" },
    { no: 4, name: "TRIBUREAU_DISPUTE_PREMIUM_UPSELL" },
    { no: 5, name: "TRIBUREAU_DISPUTE_REVIEW" },
    { no: 6, name: "LIST_DISPUTE" },
    { no: 7, name: "DEBT_NEGOTIATION_PREMIUM_UPGRADE" },
    { no: 8, name: "SELECT_DISPUTE" },
  ]);
}

/**
 * @generated from message web.public.GetCreditTribureaResponse
 */
export class GetCreditTribureaResponse extends Message<GetCreditTribureaResponse> {
  /**
   * @generated from field: web.public.GetCreditTribureaResponse.Status status = 1;
   */
  status = GetCreditTribureaResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.TribureauCredit credit_tribureau = 3;
   */
  creditTribureau?: TribureauCredit;

  /**
   * @generated from field: bool show_intro = 4 [deprecated = true];
   * @deprecated
   */
  showIntro = false;

  constructor(data?: PartialMessage<GetCreditTribureaResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetCreditTribureaResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetCreditTribureaResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "credit_tribureau", kind: "message", T: TribureauCredit },
    { no: 4, name: "show_intro", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditTribureaResponse {
    return new GetCreditTribureaResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditTribureaResponse {
    return new GetCreditTribureaResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditTribureaResponse {
    return new GetCreditTribureaResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditTribureaResponse | PlainMessage<GetCreditTribureaResponse> | undefined, b: GetCreditTribureaResponse | PlainMessage<GetCreditTribureaResponse> | undefined): boolean {
    return proto3.util.equals(GetCreditTribureaResponse, a, b);
  }

  static _enums: {
    Status: typeof GetCreditTribureaResponse.Status,
  };
}

export namespace GetCreditTribureaResponse {
  /**
   * @generated from enum web.public.GetCreditTribureaResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,

    /**
     * @generated from enum value: DELIVERY_PENDING = 3;
     */
    DELIVERY_PENDING = 3,

    /**
     * @generated from enum value: FULFILLMENT_FAILED = 4;
     */
    FULFILLMENT_FAILED = 4,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetCreditTribureaResponse.Status)
  proto3.util.setEnumType(GetCreditTribureaResponse.Status, "web.public.GetCreditTribureaResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
    { no: 3, name: "DELIVERY_PENDING" },
    { no: 4, name: "FULFILLMENT_FAILED" },
  ]);
}

/**
 * @generated from message web.public.GetAccountRequest
 */
export class GetAccountRequest extends Message<GetAccountRequest> {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId = "";

  constructor(data?: PartialMessage<GetAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountRequest {
    return new GetAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountRequest {
    return new GetAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountRequest {
    return new GetAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountRequest | PlainMessage<GetAccountRequest> | undefined, b: GetAccountRequest | PlainMessage<GetAccountRequest> | undefined): boolean {
    return proto3.util.equals(GetAccountRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetAccountResponse
 */
export class GetAccountResponse extends Message<GetAccountResponse> {
  /**
   * @generated from field: web.public.GetAccountResponse.Status status = 1;
   */
  status = GetAccountResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.AccountV2 account = 3;
   */
  account?: AccountV2;

  constructor(data?: PartialMessage<GetAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetAccountResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "account", kind: "message", T: AccountV2 },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountResponse {
    return new GetAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountResponse {
    return new GetAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountResponse {
    return new GetAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountResponse | PlainMessage<GetAccountResponse> | undefined, b: GetAccountResponse | PlainMessage<GetAccountResponse> | undefined): boolean {
    return proto3.util.equals(GetAccountResponse, a, b);
  }

  static _enums: {
    Status: typeof GetAccountResponse.Status,
  };
}

export namespace GetAccountResponse {
  /**
   * @generated from enum web.public.GetAccountResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetAccountResponse.Status)
  proto3.util.setEnumType(GetAccountResponse.Status, "web.public.GetAccountResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.GetFactorsRequest
 */
export class GetFactorsRequest extends Message<GetFactorsRequest> {
  constructor(data?: PartialMessage<GetFactorsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetFactorsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFactorsRequest {
    return new GetFactorsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFactorsRequest {
    return new GetFactorsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFactorsRequest {
    return new GetFactorsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFactorsRequest | PlainMessage<GetFactorsRequest> | undefined, b: GetFactorsRequest | PlainMessage<GetFactorsRequest> | undefined): boolean {
    return proto3.util.equals(GetFactorsRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetFactorsResponse
 */
export class GetFactorsResponse extends Message<GetFactorsResponse> {
  /**
   * @generated from field: web.public.GetFactorsResponse.Status status = 1;
   */
  status = GetFactorsResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated web.public.Factor factors = 3;
   */
  factors: Factor[] = [];

  constructor(data?: PartialMessage<GetFactorsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetFactorsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetFactorsResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "factors", kind: "message", T: Factor, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFactorsResponse {
    return new GetFactorsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFactorsResponse {
    return new GetFactorsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFactorsResponse {
    return new GetFactorsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFactorsResponse | PlainMessage<GetFactorsResponse> | undefined, b: GetFactorsResponse | PlainMessage<GetFactorsResponse> | undefined): boolean {
    return proto3.util.equals(GetFactorsResponse, a, b);
  }

  static _enums: {
    Status: typeof GetFactorsResponse.Status,
  };
}

export namespace GetFactorsResponse {
  /**
   * @generated from enum web.public.GetFactorsResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetFactorsResponse.Status)
  proto3.util.setEnumType(GetFactorsResponse.Status, "web.public.GetFactorsResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.ActivateEnrollmentRequest
 */
export class ActivateEnrollmentRequest extends Message<ActivateEnrollmentRequest> {
  constructor(data?: PartialMessage<ActivateEnrollmentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ActivateEnrollmentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivateEnrollmentRequest {
    return new ActivateEnrollmentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivateEnrollmentRequest {
    return new ActivateEnrollmentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivateEnrollmentRequest {
    return new ActivateEnrollmentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ActivateEnrollmentRequest | PlainMessage<ActivateEnrollmentRequest> | undefined, b: ActivateEnrollmentRequest | PlainMessage<ActivateEnrollmentRequest> | undefined): boolean {
    return proto3.util.equals(ActivateEnrollmentRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.ActivateEnrollmentResponse
 */
export class ActivateEnrollmentResponse extends Message<ActivateEnrollmentResponse> {
  /**
   * @generated from field: web.public.ActivateEnrollmentResponse.Status status = 1;
   */
  status = ActivateEnrollmentResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.ActivateEnrollmentResponse.EnrollmentStatus enrollment_status = 3;
   */
  enrollmentStatus = ActivateEnrollmentResponse.EnrollmentStatus.ENROLLED;

  constructor(data?: PartialMessage<ActivateEnrollmentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ActivateEnrollmentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ActivateEnrollmentResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "enrollment_status", kind: "enum", T: proto3.getEnumType(ActivateEnrollmentResponse.EnrollmentStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivateEnrollmentResponse {
    return new ActivateEnrollmentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivateEnrollmentResponse {
    return new ActivateEnrollmentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivateEnrollmentResponse {
    return new ActivateEnrollmentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ActivateEnrollmentResponse | PlainMessage<ActivateEnrollmentResponse> | undefined, b: ActivateEnrollmentResponse | PlainMessage<ActivateEnrollmentResponse> | undefined): boolean {
    return proto3.util.equals(ActivateEnrollmentResponse, a, b);
  }

  static _enums: {
    Status: typeof ActivateEnrollmentResponse.Status,
    EnrollmentStatus: typeof ActivateEnrollmentResponse.EnrollmentStatus,
  };
}

export namespace ActivateEnrollmentResponse {
  /**
   * @generated from enum web.public.ActivateEnrollmentResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ActivateEnrollmentResponse.Status)
  proto3.util.setEnumType(ActivateEnrollmentResponse.Status, "web.public.ActivateEnrollmentResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

export namespace ActivateEnrollmentResponse {
  /**
   * @generated from enum web.public.ActivateEnrollmentResponse.EnrollmentStatus
   */
  export enum EnrollmentStatus {
    /**
     * @generated from enum value: ENROLLED = 0;
     */
    ENROLLED = 0,

    /**
     * @generated from enum value: PENDING_ENROLLMENT = 1;
     */
    PENDING_ENROLLMENT = 1,

    /**
     * @generated from enum value: NOT_ENROLLED = 2;
     */
    NOT_ENROLLED = 2,

    /**
     * @generated from enum value: ENROLLMENT_STARTED = 3;
     */
    ENROLLMENT_STARTED = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ActivateEnrollmentResponse.EnrollmentStatus)
  proto3.util.setEnumType(ActivateEnrollmentResponse.EnrollmentStatus, "web.public.ActivateEnrollmentResponse.EnrollmentStatus", [
    { no: 0, name: "ENROLLED" },
    { no: 1, name: "PENDING_ENROLLMENT" },
    { no: 2, name: "NOT_ENROLLED" },
    { no: 3, name: "ENROLLMENT_STARTED" },
  ]);
}

/**
 * @generated from message web.public.CreditV2
 */
export class CreditV2 extends Message<CreditV2> {
  /**
   * @generated from field: web.public.CreditScoreV2 current_credit_score = 1;
   */
  currentCreditScore?: CreditScoreV2;

  /**
   * @generated from field: web.public.CreditScoreGainV2 credit_score_gain = 2;
   */
  creditScoreGain?: CreditScoreGainV2;

  /**
   * @generated from field: web.public.CreditScoreHistoryV2 credit_score_history = 3;
   */
  creditScoreHistory?: CreditScoreHistoryV2;

  /**
   * @generated from field: repeated web.public.AccountPreview problem_accounts = 4;
   */
  problemAccounts: AccountPreview[] = [];

  /**
   * @generated from field: repeated web.public.ScoreEvent score_events = 5 [deprecated = true];
   * @deprecated
   */
  scoreEvents: ScoreEvent[] = [];

  /**
   * @generated from field: web.public.CreditScoreTodo todo = 6;
   */
  todo?: CreditScoreTodo;

  /**
   * @generated from field: web.public.CreditScoreTodo top_todo = 7;
   */
  topTodo?: CreditScoreTodo;

  /**
   * @generated from field: repeated web.public.Factor factors = 8;
   */
  factors: Factor[] = [];

  /**
   * @generated from field: repeated web.public.AccountV2 accounts = 9;
   */
  accounts: AccountV2[] = [];

  /**
   * @generated from field: web.public.CreditScoreTodo notification = 10;
   */
  notification?: CreditScoreTodo;

  /**
   * @generated from field: web.public.CreditV2.OverviewDetail overview = 11;
   */
  overview?: CreditV2.OverviewDetail;

  /**
   * @generated from field: web.public.CreditV2.PersonalInfoDetail personal_info = 12;
   */
  personalInfo?: CreditV2.PersonalInfoDetail;

  /**
   * @generated from field: web.public.CreditV2.AddressDetail address = 13;
   */
  address?: CreditV2.AddressDetail;

  /**
   * @generated from field: repeated web.public.CreditV2.Inquiry inquiries = 14;
   */
  inquiries: CreditV2.Inquiry[] = [];

  /**
   * @generated from field: repeated web.public.CreditV2.Collection collections = 15;
   */
  collections: CreditV2.Collection[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp generated_date = 16;
   */
  generatedDate?: Timestamp;

  /**
   * @generated from field: bool frozen_file = 17;
   */
  frozenFile = false;

  /**
   * @generated from field: repeated string consumer_statements = 18;
   */
  consumerStatements: string[] = [];

  constructor(data?: PartialMessage<CreditV2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CreditV2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "current_credit_score", kind: "message", T: CreditScoreV2 },
    { no: 2, name: "credit_score_gain", kind: "message", T: CreditScoreGainV2 },
    { no: 3, name: "credit_score_history", kind: "message", T: CreditScoreHistoryV2 },
    { no: 4, name: "problem_accounts", kind: "message", T: AccountPreview, repeated: true },
    { no: 5, name: "score_events", kind: "message", T: ScoreEvent, repeated: true },
    { no: 6, name: "todo", kind: "message", T: CreditScoreTodo },
    { no: 7, name: "top_todo", kind: "message", T: CreditScoreTodo },
    { no: 8, name: "factors", kind: "message", T: Factor, repeated: true },
    { no: 9, name: "accounts", kind: "message", T: AccountV2, repeated: true },
    { no: 10, name: "notification", kind: "message", T: CreditScoreTodo },
    { no: 11, name: "overview", kind: "message", T: CreditV2.OverviewDetail },
    { no: 12, name: "personal_info", kind: "message", T: CreditV2.PersonalInfoDetail },
    { no: 13, name: "address", kind: "message", T: CreditV2.AddressDetail },
    { no: 14, name: "inquiries", kind: "message", T: CreditV2.Inquiry, repeated: true },
    { no: 15, name: "collections", kind: "message", T: CreditV2.Collection, repeated: true },
    { no: 16, name: "generated_date", kind: "message", T: Timestamp },
    { no: 17, name: "frozen_file", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "consumer_statements", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditV2 {
    return new CreditV2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditV2 {
    return new CreditV2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditV2 {
    return new CreditV2().fromJsonString(jsonString, options);
  }

  static equals(a: CreditV2 | PlainMessage<CreditV2> | undefined, b: CreditV2 | PlainMessage<CreditV2> | undefined): boolean {
    return proto3.util.equals(CreditV2, a, b);
  }

  static _enums: {
  };
}

export namespace CreditV2 {
  /**
   * @generated from message web.public.CreditV2.OverviewDetail
   */
  export class OverviewDetail extends Message<CreditV2.OverviewDetail> {
    /**
     * @generated from field: uint32 total_accounts = 1;
     */
    totalAccounts = 0;

    /**
     * @generated from field: uint32 open_accounts = 2;
     */
    openAccounts = 0;

    /**
     * @generated from field: uint32 closed_accounts = 3;
     */
    closedAccounts = 0;

    /**
     * @generated from field: uint32 debt_in_collections = 4;
     */
    debtInCollections = 0;

    /**
     * @generated from field: uint32 hard_inquiries = 5;
     */
    hardInquiries = 0;

    /**
     * @generated from field: uint32 on_time_payments_count = 6;
     */
    onTimePaymentsCount = 0;

    constructor(data?: PartialMessage<CreditV2.OverviewDetail>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.CreditV2.OverviewDetail";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "total_accounts", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 2, name: "open_accounts", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 3, name: "closed_accounts", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 4, name: "debt_in_collections", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 5, name: "hard_inquiries", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 6, name: "on_time_payments_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditV2.OverviewDetail {
      return new CreditV2.OverviewDetail().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditV2.OverviewDetail {
      return new CreditV2.OverviewDetail().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditV2.OverviewDetail {
      return new CreditV2.OverviewDetail().fromJsonString(jsonString, options);
    }

    static equals(a: CreditV2.OverviewDetail | PlainMessage<CreditV2.OverviewDetail> | undefined, b: CreditV2.OverviewDetail | PlainMessage<CreditV2.OverviewDetail> | undefined): boolean {
      return proto3.util.equals(CreditV2.OverviewDetail, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditV2 {
  /**
   * @generated from message web.public.CreditV2.PersonalInfoDetail
   */
  export class PersonalInfoDetail extends Message<CreditV2.PersonalInfoDetail> {
    /**
     * @generated from field: string name = 1;
     */
    name = "";

    /**
     * @generated from field: google.protobuf.Timestamp date_of_birth = 2;
     */
    dateOfBirth?: Timestamp;

    /**
     * @generated from field: repeated string employers = 3;
     */
    employers: string[] = [];

    /**
     * @generated from field: repeated string aliases = 4;
     */
    aliases: string[] = [];

    /**
     * @generated from field: web.public.Name full_name = 5;
     */
    fullName?: Name;

    constructor(data?: PartialMessage<CreditV2.PersonalInfoDetail>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.CreditV2.PersonalInfoDetail";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "date_of_birth", kind: "message", T: Timestamp },
      { no: 3, name: "employers", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
      { no: 4, name: "aliases", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
      { no: 5, name: "full_name", kind: "message", T: Name },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditV2.PersonalInfoDetail {
      return new CreditV2.PersonalInfoDetail().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditV2.PersonalInfoDetail {
      return new CreditV2.PersonalInfoDetail().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditV2.PersonalInfoDetail {
      return new CreditV2.PersonalInfoDetail().fromJsonString(jsonString, options);
    }

    static equals(a: CreditV2.PersonalInfoDetail | PlainMessage<CreditV2.PersonalInfoDetail> | undefined, b: CreditV2.PersonalInfoDetail | PlainMessage<CreditV2.PersonalInfoDetail> | undefined): boolean {
      return proto3.util.equals(CreditV2.PersonalInfoDetail, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditV2 {
  /**
   * @generated from message web.public.CreditV2.AddressFormat
   */
  export class AddressFormat extends Message<CreditV2.AddressFormat> {
    /**
     * @generated from field: string address_line_1 = 1;
     */
    addressLine1 = "";

    /**
     * @generated from field: string address_line_2 = 2;
     */
    addressLine2 = "";

    /**
     * @generated from field: string address_line_3 = 3;
     */
    addressLine3 = "";

    /**
     * @generated from field: string address_line_4 = 4;
     */
    addressLine4 = "";

    /**
     * @generated from field: string address_line_5 = 5;
     */
    addressLine5 = "";

    constructor(data?: PartialMessage<CreditV2.AddressFormat>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.CreditV2.AddressFormat";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "address_line_1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "address_line_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 3, name: "address_line_3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 4, name: "address_line_4", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 5, name: "address_line_5", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditV2.AddressFormat {
      return new CreditV2.AddressFormat().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditV2.AddressFormat {
      return new CreditV2.AddressFormat().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditV2.AddressFormat {
      return new CreditV2.AddressFormat().fromJsonString(jsonString, options);
    }

    static equals(a: CreditV2.AddressFormat | PlainMessage<CreditV2.AddressFormat> | undefined, b: CreditV2.AddressFormat | PlainMessage<CreditV2.AddressFormat> | undefined): boolean {
      return proto3.util.equals(CreditV2.AddressFormat, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditV2 {
  /**
   * @generated from message web.public.CreditV2.AddressDetail
   */
  export class AddressDetail extends Message<CreditV2.AddressDetail> {
    /**
     * @generated from field: web.public.CreditV2.AddressFormat current_address = 1;
     */
    currentAddress?: CreditV2.AddressFormat;

    /**
     * @generated from field: repeated web.public.CreditV2.AddressFormat previous_addresses = 2;
     */
    previousAddresses: CreditV2.AddressFormat[] = [];

    constructor(data?: PartialMessage<CreditV2.AddressDetail>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.CreditV2.AddressDetail";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "current_address", kind: "message", T: CreditV2.AddressFormat },
      { no: 2, name: "previous_addresses", kind: "message", T: CreditV2.AddressFormat, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditV2.AddressDetail {
      return new CreditV2.AddressDetail().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditV2.AddressDetail {
      return new CreditV2.AddressDetail().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditV2.AddressDetail {
      return new CreditV2.AddressDetail().fromJsonString(jsonString, options);
    }

    static equals(a: CreditV2.AddressDetail | PlainMessage<CreditV2.AddressDetail> | undefined, b: CreditV2.AddressDetail | PlainMessage<CreditV2.AddressDetail> | undefined): boolean {
      return proto3.util.equals(CreditV2.AddressDetail, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditV2 {
  /**
   * @generated from message web.public.CreditV2.Collection
   */
  export class Collection extends Message<CreditV2.Collection> {
    /**
     * @generated from field: uint32 amount_dollars = 1;
     */
    amountDollars = 0;

    /**
     * @generated from field: string status = 2;
     */
    status = "";

    /**
     * @generated from field: string provider = 3;
     */
    provider = "";

    /**
     * @generated from field: google.protobuf.Timestamp reported_at = 4;
     */
    reportedAt?: Timestamp;

    /**
     * @generated from field: string agency_client = 5;
     */
    agencyClient = "";

    /**
     * @generated from field: string original_creditor_name = 6;
     */
    originalCreditorName = "";

    /**
     * @generated from field: string account_number = 7;
     */
    accountNumber = "";

    /**
     * @generated from field: uint32 original_amount_owed_dollars = 8;
     */
    originalAmountOwedDollars = 0;

    constructor(data?: PartialMessage<CreditV2.Collection>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.CreditV2.Collection";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "amount_dollars", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 3, name: "provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 4, name: "reported_at", kind: "message", T: Timestamp },
      { no: 5, name: "agency_client", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 6, name: "original_creditor_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 7, name: "account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 8, name: "original_amount_owed_dollars", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditV2.Collection {
      return new CreditV2.Collection().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditV2.Collection {
      return new CreditV2.Collection().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditV2.Collection {
      return new CreditV2.Collection().fromJsonString(jsonString, options);
    }

    static equals(a: CreditV2.Collection | PlainMessage<CreditV2.Collection> | undefined, b: CreditV2.Collection | PlainMessage<CreditV2.Collection> | undefined): boolean {
      return proto3.util.equals(CreditV2.Collection, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditV2 {
  /**
   * @generated from message web.public.CreditV2.Inquiry
   */
  export class Inquiry extends Message<CreditV2.Inquiry> {
    /**
     * @generated from field: web.public.AccountV2.ContactInfo contact_info = 1;
     */
    contactInfo?: AccountV2.ContactInfo;

    /**
     * @generated from field: string provider = 2;
     */
    provider = "";

    /**
     * @generated from field: google.protobuf.Timestamp reported_at = 3;
     */
    reportedAt?: Timestamp;

    /**
     * @generated from field: string type = 4;
     */
    type = "";

    /**
     * @generated from field: string dispute_item_id = 5;
     */
    disputeItemId = "";

    constructor(data?: PartialMessage<CreditV2.Inquiry>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.CreditV2.Inquiry";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "contact_info", kind: "message", T: AccountV2.ContactInfo },
      { no: 2, name: "provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 3, name: "reported_at", kind: "message", T: Timestamp },
      { no: 4, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 5, name: "dispute_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditV2.Inquiry {
      return new CreditV2.Inquiry().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditV2.Inquiry {
      return new CreditV2.Inquiry().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditV2.Inquiry {
      return new CreditV2.Inquiry().fromJsonString(jsonString, options);
    }

    static equals(a: CreditV2.Inquiry | PlainMessage<CreditV2.Inquiry> | undefined, b: CreditV2.Inquiry | PlainMessage<CreditV2.Inquiry> | undefined): boolean {
      return proto3.util.equals(CreditV2.Inquiry, a, b);
    }

    static _enums: {
    };
  }
}

/**
 * @generated from message web.public.TribureauCredit
 */
export class TribureauCredit extends Message<TribureauCredit> {
  /**
   * @generated from field: web.public.CreditV2 equifax = 1;
   */
  equifax?: CreditV2;

  /**
   * @generated from field: web.public.CreditV2 transunion = 2;
   */
  transunion?: CreditV2;

  /**
   * @generated from field: web.public.CreditV2 experian = 3;
   */
  experian?: CreditV2;

  constructor(data?: PartialMessage<TribureauCredit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.TribureauCredit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "equifax", kind: "message", T: CreditV2 },
    { no: 2, name: "transunion", kind: "message", T: CreditV2 },
    { no: 3, name: "experian", kind: "message", T: CreditV2 },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TribureauCredit {
    return new TribureauCredit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TribureauCredit {
    return new TribureauCredit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TribureauCredit {
    return new TribureauCredit().fromJsonString(jsonString, options);
  }

  static equals(a: TribureauCredit | PlainMessage<TribureauCredit> | undefined, b: TribureauCredit | PlainMessage<TribureauCredit> | undefined): boolean {
    return proto3.util.equals(TribureauCredit, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.CreditScoreV2
 */
export class CreditScoreV2 extends Message<CreditScoreV2> {
  /**
   * @generated from field: google.protobuf.Timestamp generated_date = 1;
   */
  generatedDate?: Timestamp;

  /**
   * @generated from field: uint32 score = 2;
   */
  score = 0;

  constructor(data?: PartialMessage<CreditScoreV2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CreditScoreV2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "generated_date", kind: "message", T: Timestamp },
    { no: 2, name: "score", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditScoreV2 {
    return new CreditScoreV2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditScoreV2 {
    return new CreditScoreV2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditScoreV2 {
    return new CreditScoreV2().fromJsonString(jsonString, options);
  }

  static equals(a: CreditScoreV2 | PlainMessage<CreditScoreV2> | undefined, b: CreditScoreV2 | PlainMessage<CreditScoreV2> | undefined): boolean {
    return proto3.util.equals(CreditScoreV2, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.CreditScoreGainV2
 */
export class CreditScoreGainV2 extends Message<CreditScoreGainV2> {
  /**
   * @generated from field: int32 score_gain = 1;
   */
  scoreGain = 0;

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * @generated from field: string icon_url = 3;
   */
  iconUrl = "";

  /**
   * @generated from field: int32 previous_month_score_gain = 4;
   */
  previousMonthScoreGain = 0;

  constructor(data?: PartialMessage<CreditScoreGainV2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CreditScoreGainV2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "score_gain", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "previous_month_score_gain", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditScoreGainV2 {
    return new CreditScoreGainV2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditScoreGainV2 {
    return new CreditScoreGainV2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditScoreGainV2 {
    return new CreditScoreGainV2().fromJsonString(jsonString, options);
  }

  static equals(a: CreditScoreGainV2 | PlainMessage<CreditScoreGainV2> | undefined, b: CreditScoreGainV2 | PlainMessage<CreditScoreGainV2> | undefined): boolean {
    return proto3.util.equals(CreditScoreGainV2, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.CreditScoreHistoryV2
 */
export class CreditScoreHistoryV2 extends Message<CreditScoreHistoryV2> {
  /**
   * @generated from field: repeated web.public.CreditScoreV2 credit_scores = 1;
   */
  creditScores: CreditScoreV2[] = [];

  /**
   * @generated from field: uint32 chart_lower_bound = 2;
   */
  chartLowerBound = 0;

  /**
   * @generated from field: uint32 chart_upper_bound = 3;
   */
  chartUpperBound = 0;

  /**
   * @generated from field: google.protobuf.Timestamp chart_start_date = 4;
   */
  chartStartDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp chart_end_date = 5;
   */
  chartEndDate?: Timestamp;

  constructor(data?: PartialMessage<CreditScoreHistoryV2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CreditScoreHistoryV2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "credit_scores", kind: "message", T: CreditScoreV2, repeated: true },
    { no: 2, name: "chart_lower_bound", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "chart_upper_bound", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "chart_start_date", kind: "message", T: Timestamp },
    { no: 5, name: "chart_end_date", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditScoreHistoryV2 {
    return new CreditScoreHistoryV2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditScoreHistoryV2 {
    return new CreditScoreHistoryV2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditScoreHistoryV2 {
    return new CreditScoreHistoryV2().fromJsonString(jsonString, options);
  }

  static equals(a: CreditScoreHistoryV2 | PlainMessage<CreditScoreHistoryV2> | undefined, b: CreditScoreHistoryV2 | PlainMessage<CreditScoreHistoryV2> | undefined): boolean {
    return proto3.util.equals(CreditScoreHistoryV2, a, b);
  }

  static _enums: {
  };
}

/**
 * Shared proto for any list of accounts with some kind of measure and/or text
 *
 * @generated from message web.public.AccountPreview
 */
export class AccountPreview extends Message<AccountPreview> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string text = 3;
   */
  text = "";

  /**
   * @generated from field: web.public.AccountPreview.MeasureType measure_type = 4;
   */
  measureType = AccountPreview.MeasureType.UNKNOWN;

  /**
   * @generated from field: string measure_value = 5;
   */
  measureValue = "";

  /**
   * @generated from field: bool is_open = 6;
   */
  isOpen = false;

  /**
   * @generated from field: web.public.AccountPreview.AccountType account_type = 7;
   */
  accountType = AccountPreview.AccountType.REVOLVING;

  /**
   * @generated from field: bool is_kikoff_account = 8;
   */
  isKikoffAccount = false;

  constructor(data?: PartialMessage<AccountPreview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.AccountPreview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "measure_type", kind: "enum", T: proto3.getEnumType(AccountPreview.MeasureType) },
    { no: 5, name: "measure_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "is_open", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "account_type", kind: "enum", T: proto3.getEnumType(AccountPreview.AccountType) },
    { no: 8, name: "is_kikoff_account", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AccountPreview {
    return new AccountPreview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AccountPreview {
    return new AccountPreview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AccountPreview {
    return new AccountPreview().fromJsonString(jsonString, options);
  }

  static equals(a: AccountPreview | PlainMessage<AccountPreview> | undefined, b: AccountPreview | PlainMessage<AccountPreview> | undefined): boolean {
    return proto3.util.equals(AccountPreview, a, b);
  }

  static _enums: {
    MeasureType: typeof AccountPreview.MeasureType,
    AccountType: typeof AccountPreview.AccountType,
  };
}

export namespace AccountPreview {
  /**
   * Enum for types of measures presented in account previews
   *
   * @generated from enum web.public.AccountPreview.MeasureType
   */
  export enum MeasureType {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: UTILIZATION = 1;
     */
    UTILIZATION = 1,

    /**
     * @generated from enum value: BALANCE = 2;
     */
    BALANCE = 2,

    /**
     * @generated from enum value: ON_TIME_PAYMENTS = 3;
     */
    ON_TIME_PAYMENTS = 3,

    /**
     * @generated from enum value: MISSED_PAYMENTS = 4;
     */
    MISSED_PAYMENTS = 4,

    /**
     * @generated from enum value: ACCOUNT_CODE = 5;
     */
    ACCOUNT_CODE = 5,

    /**
     * @generated from enum value: CREDIT_AGE = 6;
     */
    CREDIT_AGE = 6,

    /**
     * @generated from enum value: COLLECTIONS = 7;
     */
    COLLECTIONS = 7,

    /**
     * @generated from enum value: ACCOUNT_STATUS = 8;
     */
    ACCOUNT_STATUS = 8,
  }
  // Retrieve enum metadata with: proto3.getEnumType(AccountPreview.MeasureType)
  proto3.util.setEnumType(AccountPreview.MeasureType, "web.public.AccountPreview.MeasureType", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "UTILIZATION" },
    { no: 2, name: "BALANCE" },
    { no: 3, name: "ON_TIME_PAYMENTS" },
    { no: 4, name: "MISSED_PAYMENTS" },
    { no: 5, name: "ACCOUNT_CODE" },
    { no: 6, name: "CREDIT_AGE" },
    { no: 7, name: "COLLECTIONS" },
    { no: 8, name: "ACCOUNT_STATUS" },
  ]);
}

export namespace AccountPreview {
  /**
   * @generated from enum web.public.AccountPreview.AccountType
   */
  export enum AccountType {
    /**
     * @generated from enum value: REVOLVING = 0;
     */
    REVOLVING = 0,

    /**
     * @generated from enum value: INSTALLMENT = 1;
     */
    INSTALLMENT = 1,

    /**
     * @generated from enum value: MORTGAGE = 2;
     */
    MORTGAGE = 2,

    /**
     * @generated from enum value: OTHER = 3;
     */
    OTHER = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(AccountPreview.AccountType)
  proto3.util.setEnumType(AccountPreview.AccountType, "web.public.AccountPreview.AccountType", [
    { no: 0, name: "REVOLVING" },
    { no: 1, name: "INSTALLMENT" },
    { no: 2, name: "MORTGAGE" },
    { no: 3, name: "OTHER" },
  ]);
}

/**
 * @generated from message web.public.ScoreEvent
 */
export class ScoreEvent extends Message<ScoreEvent> {
  /**
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * @generated from field: google.protobuf.Timestamp date = 2;
   */
  date?: Timestamp;

  /**
   * @generated from field: int32 score_impact = 3;
   */
  scoreImpact = 0;

  /**
   * @generated from field: string description = 4;
   */
  description = "";

  constructor(data?: PartialMessage<ScoreEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ScoreEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date", kind: "message", T: Timestamp },
    { no: 3, name: "score_impact", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ScoreEvent {
    return new ScoreEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ScoreEvent {
    return new ScoreEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ScoreEvent {
    return new ScoreEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ScoreEvent | PlainMessage<ScoreEvent> | undefined, b: ScoreEvent | PlainMessage<ScoreEvent> | undefined): boolean {
    return proto3.util.equals(ScoreEvent, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.AccountV2
 */
export class AccountV2 extends Message<AccountV2> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string type = 3;
   */
  type = "";

  /**
   * @generated from field: string message = 4;
   */
  message = "";

  /**
   * @generated from field: google.protobuf.Timestamp reported_date = 5;
   */
  reportedDate?: Timestamp;

  /**
   * @generated from field: uint32 balance_amount_dollars = 6;
   */
  balanceAmountDollars = 0;

  /**
   * @generated from field: uint32 credit_limit_amount_dollars = 7;
   */
  creditLimitAmountDollars = 0;

  /**
   * @generated from field: uint32 past_due_amount_dollars = 8;
   */
  pastDueAmountDollars = 0;

  /**
   * @generated from field: repeated web.public.AccountV2.AccountDetail details = 9;
   */
  details: AccountV2.AccountDetail[] = [];

  /**
   * @generated from field: repeated web.public.AccountV2.PaymentInfo payment_history = 10;
   */
  paymentHistory: AccountV2.PaymentInfo[] = [];

  /**
   * @generated from field: web.public.AccountV2.ContactInfo contact_info = 11;
   */
  contactInfo?: AccountV2.ContactInfo;

  /**
   * @generated from field: string account_type = 12;
   */
  accountType = "";

  /**
   * @generated from field: web.public.AccountV2.PaymentInfo.Value account_status = 13;
   */
  accountStatus = AccountV2.PaymentInfo.Value.OTHER;

  /**
   * @generated from field: bool account_open = 14;
   */
  accountOpen = false;

  /**
   * @generated from field: uint32 monthly_payment_dollars = 15;
   */
  monthlyPaymentDollars = 0;

  /**
   * @generated from field: string provider = 16;
   */
  provider = "";

  /**
   * @generated from field: google.protobuf.Timestamp date_opened = 17;
   */
  dateOpened?: Timestamp;

  /**
   * @generated from field: uint32 high_credit_amount_dollars = 18;
   */
  highCreditAmountDollars = 0;

  /**
   * @generated from field: string original_creditor_name = 19;
   */
  originalCreditorName = "";

  /**
   * @generated from field: string institution_name = 20;
   */
  institutionName = "";

  /**
   * @generated from field: optional bytes institution_logo = 21;
   */
  institutionLogo?: Uint8Array;

  /**
   * @generated from field: google.protobuf.Timestamp closed_at = 22;
   */
  closedAt?: Timestamp;

  constructor(data?: PartialMessage<AccountV2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.AccountV2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "reported_date", kind: "message", T: Timestamp },
    { no: 6, name: "balance_amount_dollars", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 7, name: "credit_limit_amount_dollars", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 8, name: "past_due_amount_dollars", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 9, name: "details", kind: "message", T: AccountV2.AccountDetail, repeated: true },
    { no: 10, name: "payment_history", kind: "message", T: AccountV2.PaymentInfo, repeated: true },
    { no: 11, name: "contact_info", kind: "message", T: AccountV2.ContactInfo },
    { no: 12, name: "account_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "account_status", kind: "enum", T: proto3.getEnumType(AccountV2.PaymentInfo.Value) },
    { no: 14, name: "account_open", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "monthly_payment_dollars", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 16, name: "provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "date_opened", kind: "message", T: Timestamp },
    { no: 18, name: "high_credit_amount_dollars", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 19, name: "original_creditor_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "institution_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "institution_logo", kind: "scalar", T: 12 /* ScalarType.BYTES */, opt: true },
    { no: 22, name: "closed_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AccountV2 {
    return new AccountV2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AccountV2 {
    return new AccountV2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AccountV2 {
    return new AccountV2().fromJsonString(jsonString, options);
  }

  static equals(a: AccountV2 | PlainMessage<AccountV2> | undefined, b: AccountV2 | PlainMessage<AccountV2> | undefined): boolean {
    return proto3.util.equals(AccountV2, a, b);
  }

  static _enums: {
  };
}

export namespace AccountV2 {
  /**
   * @generated from message web.public.AccountV2.PaymentInfo
   */
  export class PaymentInfo extends Message<AccountV2.PaymentInfo> {
    /**
     * @generated from field: google.protobuf.Timestamp payment_time = 1;
     */
    paymentTime?: Timestamp;

    /**
     * @generated from field: web.public.AccountV2.PaymentInfo.Value value = 2;
     */
    value = AccountV2.PaymentInfo.Value.OTHER;

    constructor(data?: PartialMessage<AccountV2.PaymentInfo>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.AccountV2.PaymentInfo";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "payment_time", kind: "message", T: Timestamp },
      { no: 2, name: "value", kind: "enum", T: proto3.getEnumType(AccountV2.PaymentInfo.Value) },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AccountV2.PaymentInfo {
      return new AccountV2.PaymentInfo().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AccountV2.PaymentInfo {
      return new AccountV2.PaymentInfo().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AccountV2.PaymentInfo {
      return new AccountV2.PaymentInfo().fromJsonString(jsonString, options);
    }

    static equals(a: AccountV2.PaymentInfo | PlainMessage<AccountV2.PaymentInfo> | undefined, b: AccountV2.PaymentInfo | PlainMessage<AccountV2.PaymentInfo> | undefined): boolean {
      return proto3.util.equals(AccountV2.PaymentInfo, a, b);
    }

    static _enums: {
      Value: typeof AccountV2.PaymentInfo.Value,
    };
  }
}

export namespace AccountV2.PaymentInfo {
  /**
   * @generated from enum web.public.AccountV2.PaymentInfo.Value
   */
  export enum Value {
    /**
     * @generated from enum value: OTHER = 0;
     */
    OTHER = 0,

    /**
     * @generated from enum value: PAYS_AS_AGREED = 1;
     */
    PAYS_AS_AGREED = 1,

    /**
     * @generated from enum value: UNAVAILABLE = 2;
     */
    UNAVAILABLE = 2,

    /**
     * @generated from enum value: DAYSLATE_30 = 3;
     */
    DAYSLATE_30 = 3,

    /**
     * @generated from enum value: DAYSLATE_60 = 4;
     */
    DAYSLATE_60 = 4,

    /**
     * @generated from enum value: DAYSLATE_90 = 5;
     */
    DAYSLATE_90 = 5,

    /**
     * @generated from enum value: DAYSLATE_120 = 6;
     */
    DAYSLATE_120 = 6,

    /**
     * @generated from enum value: CHARGE_OFF = 7;
     */
    CHARGE_OFF = 7,

    /**
     * @generated from enum value: COLLECTION = 8;
     */
    COLLECTION = 8,

    /**
     * @generated from enum value: REPOSSESSION = 9;
     */
    REPOSSESSION = 9,

    /**
     * @generated from enum value: ZERO_BAL_AND_CURR_ACCT = 10;
     */
    ZERO_BAL_AND_CURR_ACCT = 10,

    /**
     * @generated from enum value: NOT_REPORTED = 11;
     */
    NOT_REPORTED = 11,

    /**
     * @generated from enum value: COLLECTION_CHARGEOFF = 12;
     */
    COLLECTION_CHARGEOFF = 12,

    /**
     * @generated from enum value: LATE_30_DAYS = 13;
     */
    LATE_30_DAYS = 13,

    /**
     * @generated from enum value: LATE_60_DAYS = 14;
     */
    LATE_60_DAYS = 14,

    /**
     * @generated from enum value: LATE_90_DAYS = 15;
     */
    LATE_90_DAYS = 15,

    /**
     * @generated from enum value: OVER_120_DAYS_PAST_DUE = 16;
     */
    OVER_120_DAYS_PAST_DUE = 16,
  }
  // Retrieve enum metadata with: proto3.getEnumType(AccountV2.PaymentInfo.Value)
  proto3.util.setEnumType(AccountV2.PaymentInfo.Value, "web.public.AccountV2.PaymentInfo.Value", [
    { no: 0, name: "OTHER" },
    { no: 1, name: "PAYS_AS_AGREED" },
    { no: 2, name: "UNAVAILABLE" },
    { no: 3, name: "DAYSLATE_30" },
    { no: 4, name: "DAYSLATE_60" },
    { no: 5, name: "DAYSLATE_90" },
    { no: 6, name: "DAYSLATE_120" },
    { no: 7, name: "CHARGE_OFF" },
    { no: 8, name: "COLLECTION" },
    { no: 9, name: "REPOSSESSION" },
    { no: 10, name: "ZERO_BAL_AND_CURR_ACCT" },
    { no: 11, name: "NOT_REPORTED" },
    { no: 12, name: "COLLECTION_CHARGEOFF" },
    { no: 13, name: "LATE_30_DAYS" },
    { no: 14, name: "LATE_60_DAYS" },
    { no: 15, name: "LATE_90_DAYS" },
    { no: 16, name: "OVER_120_DAYS_PAST_DUE" },
  ]);
}

export namespace AccountV2 {
  /**
   * @generated from message web.public.AccountV2.AccountDetail
   */
  export class AccountDetail extends Message<AccountV2.AccountDetail> {
    /**
     * @generated from field: string id = 1;
     */
    id = "";

    /**
     * @generated from field: string name = 2;
     */
    name = "";

    /**
     * @generated from field: string value = 3;
     */
    value = "";

    constructor(data?: PartialMessage<AccountV2.AccountDetail>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.AccountV2.AccountDetail";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 3, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AccountV2.AccountDetail {
      return new AccountV2.AccountDetail().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AccountV2.AccountDetail {
      return new AccountV2.AccountDetail().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AccountV2.AccountDetail {
      return new AccountV2.AccountDetail().fromJsonString(jsonString, options);
    }

    static equals(a: AccountV2.AccountDetail | PlainMessage<AccountV2.AccountDetail> | undefined, b: AccountV2.AccountDetail | PlainMessage<AccountV2.AccountDetail> | undefined): boolean {
      return proto3.util.equals(AccountV2.AccountDetail, a, b);
    }

    static _enums: {
    };
  }
}

export namespace AccountV2 {
  /**
   * @generated from message web.public.AccountV2.ContactInfo
   */
  export class ContactInfo extends Message<AccountV2.ContactInfo> {
    /**
     * @generated from field: string name = 1;
     */
    name = "";

    /**
     * @generated from field: string address_line_1 = 2;
     */
    addressLine1 = "";

    /**
     * @generated from field: string address_line_2 = 3;
     */
    addressLine2 = "";

    /**
     * @generated from field: string phone_number = 4;
     */
    phoneNumber = "";

    /**
     * @generated from field: web.public.Address address = 5;
     */
    address?: Address;

    constructor(data?: PartialMessage<AccountV2.ContactInfo>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.AccountV2.ContactInfo";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "address_line_1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 3, name: "address_line_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 4, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 5, name: "address", kind: "message", T: Address },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AccountV2.ContactInfo {
      return new AccountV2.ContactInfo().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AccountV2.ContactInfo {
      return new AccountV2.ContactInfo().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AccountV2.ContactInfo {
      return new AccountV2.ContactInfo().fromJsonString(jsonString, options);
    }

    static equals(a: AccountV2.ContactInfo | PlainMessage<AccountV2.ContactInfo> | undefined, b: AccountV2.ContactInfo | PlainMessage<AccountV2.ContactInfo> | undefined): boolean {
      return proto3.util.equals(AccountV2.ContactInfo, a, b);
    }

    static _enums: {
    };
  }
}

/**
 * @generated from message web.public.Factor
 */
export class Factor extends Message<Factor> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: web.public.Factor.Grade grade = 2;
   */
  grade = Factor.Grade.NA;

  /**
   * @generated from field: web.public.Factor.Impact impact = 3;
   */
  impact = Factor.Impact.LOW;

  /**
   * @generated from field: string message = 4;
   */
  message = "";

  /**
   * @generated from oneof web.public.Factor.details
   */
  details: {
    /**
     * @generated from field: web.public.Factor.CardUsage card_usage = 5;
     */
    value: Factor.CardUsage;
    case: "cardUsage";
  } | {
    /**
     * @generated from field: web.public.Factor.PaymentHistory payment_history = 6;
     */
    value: Factor.PaymentHistory;
    case: "paymentHistory";
  } | {
    /**
     * @generated from field: web.public.Factor.CreditMix credit_mix = 7;
     */
    value: Factor.CreditMix;
    case: "creditMix";
  } | {
    /**
     * @generated from field: web.public.Factor.DerogatoryMarks derogatory_marks = 8;
     */
    value: Factor.DerogatoryMarks;
    case: "derogatoryMarks";
  } | {
    /**
     * @generated from field: web.public.Factor.CreditAge credit_age = 9;
     */
    value: Factor.CreditAge;
    case: "creditAge";
  } | {
    /**
     * @generated from field: web.public.Factor.HardInquiries hard_inquiries = 10;
     */
    value: Factor.HardInquiries;
    case: "hardInquiries";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * @generated from field: web.public.CreditScoreTodo todo = 11;
   */
  todo?: CreditScoreTodo;

  /**
   * @generated from field: int32 factor_diff = 12;
   */
  factorDiff = 0;

  /**
   * @generated from field: int32 value = 13;
   */
  value = 0;

  /**
   * @generated from field: int32 factor_diff_time_delta_days = 14;
   */
  factorDiffTimeDeltaDays = 0;

  constructor(data?: PartialMessage<Factor>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.Factor";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "grade", kind: "enum", T: proto3.getEnumType(Factor.Grade) },
    { no: 3, name: "impact", kind: "enum", T: proto3.getEnumType(Factor.Impact) },
    { no: 4, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "card_usage", kind: "message", T: Factor.CardUsage, oneof: "details" },
    { no: 6, name: "payment_history", kind: "message", T: Factor.PaymentHistory, oneof: "details" },
    { no: 7, name: "credit_mix", kind: "message", T: Factor.CreditMix, oneof: "details" },
    { no: 8, name: "derogatory_marks", kind: "message", T: Factor.DerogatoryMarks, oneof: "details" },
    { no: 9, name: "credit_age", kind: "message", T: Factor.CreditAge, oneof: "details" },
    { no: 10, name: "hard_inquiries", kind: "message", T: Factor.HardInquiries, oneof: "details" },
    { no: 11, name: "todo", kind: "message", T: CreditScoreTodo },
    { no: 12, name: "factor_diff", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "factor_diff_time_delta_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Factor {
    return new Factor().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Factor {
    return new Factor().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Factor {
    return new Factor().fromJsonString(jsonString, options);
  }

  static equals(a: Factor | PlainMessage<Factor> | undefined, b: Factor | PlainMessage<Factor> | undefined): boolean {
    return proto3.util.equals(Factor, a, b);
  }

  static _enums: {
    Grade: typeof Factor.Grade,
    Impact: typeof Factor.Impact,
  };
}

export namespace Factor {
  /**
   * @generated from enum web.public.Factor.Grade
   */
  export enum Grade {
    /**
     * @generated from enum value: NA = 0;
     */
    NA = 0,

    /**
     * @generated from enum value: A = 1;
     */
    A = 1,

    /**
     * @generated from enum value: B = 2;
     */
    B = 2,

    /**
     * @generated from enum value: C = 3;
     */
    C = 3,

    /**
     * @generated from enum value: D = 4;
     */
    D = 4,
  }
  // Retrieve enum metadata with: proto3.getEnumType(Factor.Grade)
  proto3.util.setEnumType(Factor.Grade, "web.public.Factor.Grade", [
    { no: 0, name: "NA" },
    { no: 1, name: "A" },
    { no: 2, name: "B" },
    { no: 3, name: "C" },
    { no: 4, name: "D" },
  ]);
}

export namespace Factor {
  /**
   * @generated from enum web.public.Factor.Impact
   */
  export enum Impact {
    /**
     * @generated from enum value: LOW = 0;
     */
    LOW = 0,

    /**
     * @generated from enum value: MEDIUM = 1;
     */
    MEDIUM = 1,

    /**
     * @generated from enum value: HIGH = 2;
     */
    HIGH = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(Factor.Impact)
  proto3.util.setEnumType(Factor.Impact, "web.public.Factor.Impact", [
    { no: 0, name: "LOW" },
    { no: 1, name: "MEDIUM" },
    { no: 2, name: "HIGH" },
  ]);
}

export namespace Factor {
  /**
   * @generated from message web.public.Factor.CardUsage
   */
  export class CardUsage extends Message<Factor.CardUsage> {
    /**
     * @generated from field: web.public.Factor.CardUsage.Utilization kikoff_utilization = 1;
     */
    kikoffUtilization?: Factor.CardUsage.Utilization;

    /**
     * @generated from field: web.public.Factor.CardUsage.Utilization total_utilization = 2;
     */
    totalUtilization?: Factor.CardUsage.Utilization;

    /**
     * @generated from field: repeated web.public.AccountPreview accounts = 3;
     */
    accounts: AccountPreview[] = [];

    constructor(data?: PartialMessage<Factor.CardUsage>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.Factor.CardUsage";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "kikoff_utilization", kind: "message", T: Factor.CardUsage.Utilization },
      { no: 2, name: "total_utilization", kind: "message", T: Factor.CardUsage.Utilization },
      { no: 3, name: "accounts", kind: "message", T: AccountPreview, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Factor.CardUsage {
      return new Factor.CardUsage().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Factor.CardUsage {
      return new Factor.CardUsage().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Factor.CardUsage {
      return new Factor.CardUsage().fromJsonString(jsonString, options);
    }

    static equals(a: Factor.CardUsage | PlainMessage<Factor.CardUsage> | undefined, b: Factor.CardUsage | PlainMessage<Factor.CardUsage> | undefined): boolean {
      return proto3.util.equals(Factor.CardUsage, a, b);
    }

    static _enums: {
    };
  }
}

export namespace Factor.CardUsage {
  /**
   * @generated from message web.public.Factor.CardUsage.Utilization
   */
  export class Utilization extends Message<Factor.CardUsage.Utilization> {
    /**
     * @generated from field: string name = 1;
     */
    name = "";

    /**
     * @generated from field: uint32 balance = 2;
     */
    balance = 0;

    /**
     * @generated from field: uint32 limit = 3;
     */
    limit = 0;

    constructor(data?: PartialMessage<Factor.CardUsage.Utilization>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.Factor.CardUsage.Utilization";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "balance", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 3, name: "limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Factor.CardUsage.Utilization {
      return new Factor.CardUsage.Utilization().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Factor.CardUsage.Utilization {
      return new Factor.CardUsage.Utilization().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Factor.CardUsage.Utilization {
      return new Factor.CardUsage.Utilization().fromJsonString(jsonString, options);
    }

    static equals(a: Factor.CardUsage.Utilization | PlainMessage<Factor.CardUsage.Utilization> | undefined, b: Factor.CardUsage.Utilization | PlainMessage<Factor.CardUsage.Utilization> | undefined): boolean {
      return proto3.util.equals(Factor.CardUsage.Utilization, a, b);
    }

    static _enums: {
    };
  }
}

export namespace Factor {
  /**
   * @generated from message web.public.Factor.PaymentHistory
   */
  export class PaymentHistory extends Message<Factor.PaymentHistory> {
    /**
     * @generated from field: repeated web.public.AccountPreview accounts = 1;
     */
    accounts: AccountPreview[] = [];

    constructor(data?: PartialMessage<Factor.PaymentHistory>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.Factor.PaymentHistory";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "accounts", kind: "message", T: AccountPreview, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Factor.PaymentHistory {
      return new Factor.PaymentHistory().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Factor.PaymentHistory {
      return new Factor.PaymentHistory().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Factor.PaymentHistory {
      return new Factor.PaymentHistory().fromJsonString(jsonString, options);
    }

    static equals(a: Factor.PaymentHistory | PlainMessage<Factor.PaymentHistory> | undefined, b: Factor.PaymentHistory | PlainMessage<Factor.PaymentHistory> | undefined): boolean {
      return proto3.util.equals(Factor.PaymentHistory, a, b);
    }

    static _enums: {
    };
  }
}

export namespace Factor {
  /**
   * @generated from message web.public.Factor.CreditMix
   */
  export class CreditMix extends Message<Factor.CreditMix> {
    /**
     * @generated from field: repeated web.public.AccountPreview accounts = 1;
     */
    accounts: AccountPreview[] = [];

    constructor(data?: PartialMessage<Factor.CreditMix>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.Factor.CreditMix";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "accounts", kind: "message", T: AccountPreview, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Factor.CreditMix {
      return new Factor.CreditMix().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Factor.CreditMix {
      return new Factor.CreditMix().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Factor.CreditMix {
      return new Factor.CreditMix().fromJsonString(jsonString, options);
    }

    static equals(a: Factor.CreditMix | PlainMessage<Factor.CreditMix> | undefined, b: Factor.CreditMix | PlainMessage<Factor.CreditMix> | undefined): boolean {
      return proto3.util.equals(Factor.CreditMix, a, b);
    }

    static _enums: {
    };
  }
}

export namespace Factor {
  /**
   * @generated from message web.public.Factor.DerogatoryMarks
   */
  export class DerogatoryMarks extends Message<Factor.DerogatoryMarks> {
    /**
     * @generated from field: uint32 collections_count = 1;
     */
    collectionsCount = 0;

    /**
     * @generated from field: uint32 public_records_count = 2;
     */
    publicRecordsCount = 0;

    /**
     * @generated from field: repeated web.public.AccountPreview accounts = 3;
     */
    accounts: AccountPreview[] = [];

    constructor(data?: PartialMessage<Factor.DerogatoryMarks>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.Factor.DerogatoryMarks";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "collections_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 2, name: "public_records_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 3, name: "accounts", kind: "message", T: AccountPreview, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Factor.DerogatoryMarks {
      return new Factor.DerogatoryMarks().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Factor.DerogatoryMarks {
      return new Factor.DerogatoryMarks().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Factor.DerogatoryMarks {
      return new Factor.DerogatoryMarks().fromJsonString(jsonString, options);
    }

    static equals(a: Factor.DerogatoryMarks | PlainMessage<Factor.DerogatoryMarks> | undefined, b: Factor.DerogatoryMarks | PlainMessage<Factor.DerogatoryMarks> | undefined): boolean {
      return proto3.util.equals(Factor.DerogatoryMarks, a, b);
    }

    static _enums: {
    };
  }
}

export namespace Factor {
  /**
   * @generated from message web.public.Factor.CreditAge
   */
  export class CreditAge extends Message<Factor.CreditAge> {
    /**
     * @generated from field: uint32 oldest_age_months = 1;
     */
    oldestAgeMonths = 0;

    /**
     * @generated from field: uint32 average_age_months = 2;
     */
    averageAgeMonths = 0;

    /**
     * @generated from field: repeated web.public.AccountPreview accounts = 3;
     */
    accounts: AccountPreview[] = [];

    constructor(data?: PartialMessage<Factor.CreditAge>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.Factor.CreditAge";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "oldest_age_months", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 2, name: "average_age_months", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 3, name: "accounts", kind: "message", T: AccountPreview, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Factor.CreditAge {
      return new Factor.CreditAge().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Factor.CreditAge {
      return new Factor.CreditAge().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Factor.CreditAge {
      return new Factor.CreditAge().fromJsonString(jsonString, options);
    }

    static equals(a: Factor.CreditAge | PlainMessage<Factor.CreditAge> | undefined, b: Factor.CreditAge | PlainMessage<Factor.CreditAge> | undefined): boolean {
      return proto3.util.equals(Factor.CreditAge, a, b);
    }

    static _enums: {
    };
  }
}

export namespace Factor {
  /**
   * @generated from message web.public.Factor.HardInquiries
   */
  export class HardInquiries extends Message<Factor.HardInquiries> {
    /**
     * @generated from field: uint32 hard_inquiries_count = 1;
     */
    hardInquiriesCount = 0;

    constructor(data?: PartialMessage<Factor.HardInquiries>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.Factor.HardInquiries";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "hard_inquiries_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Factor.HardInquiries {
      return new Factor.HardInquiries().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Factor.HardInquiries {
      return new Factor.HardInquiries().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Factor.HardInquiries {
      return new Factor.HardInquiries().fromJsonString(jsonString, options);
    }

    static equals(a: Factor.HardInquiries | PlainMessage<Factor.HardInquiries> | undefined, b: Factor.HardInquiries | PlainMessage<Factor.HardInquiries> | undefined): boolean {
      return proto3.util.equals(Factor.HardInquiries, a, b);
    }

    static _enums: {
    };
  }
}

/**
 * @generated from message web.public.CreditScoreTodo
 */
export class CreditScoreTodo extends Message<CreditScoreTodo> {
  /**
   * @generated from field: string icon_url = 1;
   */
  iconUrl = "";

  /**
   * @generated from field: repeated web.public.CreditScoreTodo.Component components = 2;
   */
  components: CreditScoreTodo.Component[] = [];

  /**
   * @generated from field: web.public.CreditScoreTodo.Variant variant = 3;
   */
  variant = CreditScoreTodo.Variant.DEFAULT;

  constructor(data?: PartialMessage<CreditScoreTodo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CreditScoreTodo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "components", kind: "message", T: CreditScoreTodo.Component, repeated: true },
    { no: 3, name: "variant", kind: "enum", T: proto3.getEnumType(CreditScoreTodo.Variant) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditScoreTodo {
    return new CreditScoreTodo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditScoreTodo {
    return new CreditScoreTodo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditScoreTodo {
    return new CreditScoreTodo().fromJsonString(jsonString, options);
  }

  static equals(a: CreditScoreTodo | PlainMessage<CreditScoreTodo> | undefined, b: CreditScoreTodo | PlainMessage<CreditScoreTodo> | undefined): boolean {
    return proto3.util.equals(CreditScoreTodo, a, b);
  }

  static _enums: {
    Variant: typeof CreditScoreTodo.Variant,
  };
}

export namespace CreditScoreTodo {
  /**
   * @generated from enum web.public.CreditScoreTodo.Variant
   */
  export enum Variant {
    /**
     * @generated from enum value: DEFAULT = 0;
     */
    DEFAULT = 0,

    /**
     * @generated from enum value: COACH = 1;
     */
    COACH = 1,

    /**
     * @generated from enum value: DEBT_SETTLEMENT = 3;
     */
    DEBT_SETTLEMENT = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CreditScoreTodo.Variant)
  proto3.util.setEnumType(CreditScoreTodo.Variant, "web.public.CreditScoreTodo.Variant", [
    { no: 0, name: "DEFAULT" },
    { no: 1, name: "COACH" },
    { no: 3, name: "DEBT_SETTLEMENT" },
  ]);
}

export namespace CreditScoreTodo {
  /**
   * @generated from message web.public.CreditScoreTodo.Button
   */
  export class Button extends Message<CreditScoreTodo.Button> {
    /**
     * @generated from field: string button_text = 1;
     */
    buttonText = "";

    /**
     * @generated from field: string button_url = 2;
     */
    buttonUrl = "";

    constructor(data?: PartialMessage<CreditScoreTodo.Button>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.CreditScoreTodo.Button";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "button_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditScoreTodo.Button {
      return new CreditScoreTodo.Button().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditScoreTodo.Button {
      return new CreditScoreTodo.Button().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditScoreTodo.Button {
      return new CreditScoreTodo.Button().fromJsonString(jsonString, options);
    }

    static equals(a: CreditScoreTodo.Button | PlainMessage<CreditScoreTodo.Button> | undefined, b: CreditScoreTodo.Button | PlainMessage<CreditScoreTodo.Button> | undefined): boolean {
      return proto3.util.equals(CreditScoreTodo.Button, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditScoreTodo {
  /**
   * @generated from message web.public.CreditScoreTodo.Component
   */
  export class Component extends Message<CreditScoreTodo.Component> {
    /**
     * @generated from oneof web.public.CreditScoreTodo.Component.item
     */
    item: {
      /**
       * @generated from field: string content_md = 1;
       */
      value: string;
      case: "contentMd";
    } | {
      /**
       * @generated from field: web.public.CreditScoreTodo.Button button = 2;
       */
      value: CreditScoreTodo.Button;
      case: "button";
    } | { case: undefined; value?: undefined } = { case: undefined };

    constructor(data?: PartialMessage<CreditScoreTodo.Component>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.CreditScoreTodo.Component";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "content_md", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "item" },
      { no: 2, name: "button", kind: "message", T: CreditScoreTodo.Button, oneof: "item" },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditScoreTodo.Component {
      return new CreditScoreTodo.Component().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditScoreTodo.Component {
      return new CreditScoreTodo.Component().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditScoreTodo.Component {
      return new CreditScoreTodo.Component().fromJsonString(jsonString, options);
    }

    static equals(a: CreditScoreTodo.Component | PlainMessage<CreditScoreTodo.Component> | undefined, b: CreditScoreTodo.Component | PlainMessage<CreditScoreTodo.Component> | undefined): boolean {
      return proto3.util.equals(CreditScoreTodo.Component, a, b);
    }

    static _enums: {
    };
  }
}

/**
 * @generated from message web.public.GetCreditChangesRequest
 */
export class GetCreditChangesRequest extends Message<GetCreditChangesRequest> {
  /**
   * @generated from field: web.public.CreditBureau bureau = 1;
   */
  bureau = CreditBureau.EQUIFAX;

  constructor(data?: PartialMessage<GetCreditChangesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetCreditChangesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "bureau", kind: "enum", T: proto3.getEnumType(CreditBureau) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditChangesRequest {
    return new GetCreditChangesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditChangesRequest {
    return new GetCreditChangesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditChangesRequest {
    return new GetCreditChangesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditChangesRequest | PlainMessage<GetCreditChangesRequest> | undefined, b: GetCreditChangesRequest | PlainMessage<GetCreditChangesRequest> | undefined): boolean {
    return proto3.util.equals(GetCreditChangesRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetCreditChangesResponse
 */
export class GetCreditChangesResponse extends Message<GetCreditChangesResponse> {
  /**
   * @generated from field: web.public.GetCreditChangesResponse.Status status = 1;
   */
  status = GetCreditChangesResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated web.public.CreditChangeItem items = 3;
   */
  items: CreditChangeItem[] = [];

  constructor(data?: PartialMessage<GetCreditChangesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetCreditChangesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetCreditChangesResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "items", kind: "message", T: CreditChangeItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditChangesResponse {
    return new GetCreditChangesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditChangesResponse {
    return new GetCreditChangesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditChangesResponse {
    return new GetCreditChangesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditChangesResponse | PlainMessage<GetCreditChangesResponse> | undefined, b: GetCreditChangesResponse | PlainMessage<GetCreditChangesResponse> | undefined): boolean {
    return proto3.util.equals(GetCreditChangesResponse, a, b);
  }

  static _enums: {
    Status: typeof GetCreditChangesResponse.Status,
  };
}

export namespace GetCreditChangesResponse {
  /**
   * @generated from enum web.public.GetCreditChangesResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetCreditChangesResponse.Status)
  proto3.util.setEnumType(GetCreditChangesResponse.Status, "web.public.GetCreditChangesResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

/**
 * @generated from message web.public.CreditChangeItem
 */
export class CreditChangeItem extends Message<CreditChangeItem> {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId = "";

  /**
   * @generated from field: google.protobuf.Timestamp current_report_generated_date = 2;
   */
  currentReportGeneratedDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp previous_report_generated_date = 3;
   */
  previousReportGeneratedDate?: Timestamp;

  /**
   * @generated from field: int32 score = 4;
   */
  score = 0;

  /**
   * @generated from field: int32 score_change = 5;
   */
  scoreChange = 0;

  /**
   * @generated from field: web.public.CreditChangeItem.CreditChanges positive = 6;
   */
  positive?: CreditChangeItem.CreditChanges;

  /**
   * @generated from field: web.public.CreditChangeItem.CreditChanges noteworthy = 7;
   */
  noteworthy?: CreditChangeItem.CreditChanges;

  constructor(data?: PartialMessage<CreditChangeItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CreditChangeItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "current_report_generated_date", kind: "message", T: Timestamp },
    { no: 3, name: "previous_report_generated_date", kind: "message", T: Timestamp },
    { no: 4, name: "score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "score_change", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "positive", kind: "message", T: CreditChangeItem.CreditChanges },
    { no: 7, name: "noteworthy", kind: "message", T: CreditChangeItem.CreditChanges },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditChangeItem {
    return new CreditChangeItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditChangeItem {
    return new CreditChangeItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditChangeItem {
    return new CreditChangeItem().fromJsonString(jsonString, options);
  }

  static equals(a: CreditChangeItem | PlainMessage<CreditChangeItem> | undefined, b: CreditChangeItem | PlainMessage<CreditChangeItem> | undefined): boolean {
    return proto3.util.equals(CreditChangeItem, a, b);
  }

  static _enums: {
  };
}

export namespace CreditChangeItem {
  /**
   * @generated from message web.public.CreditChangeItem.CreditChanges
   */
  export class CreditChanges extends Message<CreditChangeItem.CreditChanges> {
    /**
     * @generated from field: web.public.CreditChangeItem.CreditChanges.ChangeType type = 1;
     */
    type = CreditChangeItem.CreditChanges.ChangeType.POSITIVE;

    /**
     * @generated from field: repeated web.public.CreditChangeItem.CreditChanges.CreditChangeDetails details = 2;
     */
    details: CreditChangeItem.CreditChanges.CreditChangeDetails[] = [];

    constructor(data?: PartialMessage<CreditChangeItem.CreditChanges>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.CreditChangeItem.CreditChanges";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(CreditChangeItem.CreditChanges.ChangeType) },
      { no: 2, name: "details", kind: "message", T: CreditChangeItem.CreditChanges.CreditChangeDetails, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditChangeItem.CreditChanges {
      return new CreditChangeItem.CreditChanges().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditChangeItem.CreditChanges {
      return new CreditChangeItem.CreditChanges().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditChangeItem.CreditChanges {
      return new CreditChangeItem.CreditChanges().fromJsonString(jsonString, options);
    }

    static equals(a: CreditChangeItem.CreditChanges | PlainMessage<CreditChangeItem.CreditChanges> | undefined, b: CreditChangeItem.CreditChanges | PlainMessage<CreditChangeItem.CreditChanges> | undefined): boolean {
      return proto3.util.equals(CreditChangeItem.CreditChanges, a, b);
    }

    static _enums: {
      ChangeType: typeof CreditChangeItem.CreditChanges.ChangeType,
    };
  }
}

export namespace CreditChangeItem.CreditChanges {
  /**
   * @generated from enum web.public.CreditChangeItem.CreditChanges.ChangeType
   */
  export enum ChangeType {
    /**
     * @generated from enum value: POSITIVE = 0;
     */
    POSITIVE = 0,

    /**
     * @generated from enum value: NOTEWORTHY = 1;
     */
    NOTEWORTHY = 1,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CreditChangeItem.CreditChanges.ChangeType)
  proto3.util.setEnumType(CreditChangeItem.CreditChanges.ChangeType, "web.public.CreditChangeItem.CreditChanges.ChangeType", [
    { no: 0, name: "POSITIVE" },
    { no: 1, name: "NOTEWORTHY" },
  ]);
}

export namespace CreditChangeItem.CreditChanges {
  /**
   * @generated from message web.public.CreditChangeItem.CreditChanges.CreditChangeDetails
   */
  export class CreditChangeDetails extends Message<CreditChangeItem.CreditChanges.CreditChangeDetails> {
    /**
     * @generated from field: web.public.CreditChangeItem.CreditChanges.CreditChangeDetails.EventType event_type = 1;
     */
    eventType = CreditChangeItem.CreditChanges.CreditChangeDetails.EventType.BALANCE_DECREASE;

    /**
     * @generated from field: repeated web.public.FactorType impacted_factors = 2;
     */
    impactedFactors: FactorType[] = [];

    /**
     * @generated from field: repeated web.public.CreditChangeItem.CreditChanges.CreditChangeDetails.Event events = 3;
     */
    events: CreditChangeItem.CreditChanges.CreditChangeDetails.Event[] = [];

    constructor(data?: PartialMessage<CreditChangeItem.CreditChanges.CreditChangeDetails>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.CreditChangeItem.CreditChanges.CreditChangeDetails";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "event_type", kind: "enum", T: proto3.getEnumType(CreditChangeItem.CreditChanges.CreditChangeDetails.EventType) },
      { no: 2, name: "impacted_factors", kind: "enum", T: proto3.getEnumType(FactorType), repeated: true },
      { no: 3, name: "events", kind: "message", T: CreditChangeItem.CreditChanges.CreditChangeDetails.Event, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditChangeItem.CreditChanges.CreditChangeDetails {
      return new CreditChangeItem.CreditChanges.CreditChangeDetails().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditChangeItem.CreditChanges.CreditChangeDetails {
      return new CreditChangeItem.CreditChanges.CreditChangeDetails().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditChangeItem.CreditChanges.CreditChangeDetails {
      return new CreditChangeItem.CreditChanges.CreditChangeDetails().fromJsonString(jsonString, options);
    }

    static equals(a: CreditChangeItem.CreditChanges.CreditChangeDetails | PlainMessage<CreditChangeItem.CreditChanges.CreditChangeDetails> | undefined, b: CreditChangeItem.CreditChanges.CreditChangeDetails | PlainMessage<CreditChangeItem.CreditChanges.CreditChangeDetails> | undefined): boolean {
      return proto3.util.equals(CreditChangeItem.CreditChanges.CreditChangeDetails, a, b);
    }

    static _enums: {
      EventType: typeof CreditChangeItem.CreditChanges.CreditChangeDetails.EventType,
      EventSubType: typeof CreditChangeItem.CreditChanges.CreditChangeDetails.EventSubType,
    };
  }
}

export namespace CreditChangeItem.CreditChanges.CreditChangeDetails {
  /**
   * @generated from enum web.public.CreditChangeItem.CreditChanges.CreditChangeDetails.EventType
   */
  export enum EventType {
    /**
     * @generated from enum value: BALANCE_DECREASE = 0;
     */
    BALANCE_DECREASE = 0,

    /**
     * @generated from enum value: BALANCE_INCREASE = 1;
     */
    BALANCE_INCREASE = 1,

    /**
     * @generated from enum value: MISSED_PAYMENT = 2;
     */
    MISSED_PAYMENT = 2,

    /**
     * @generated from enum value: ON_TIME_PAYMENT = 3;
     */
    ON_TIME_PAYMENT = 3,

    /**
     * @generated from enum value: CHARGE_OFF = 4;
     */
    CHARGE_OFF = 4,

    /**
     * @generated from enum value: COLLECTION = 5;
     */
    COLLECTION = 5,

    /**
     * @generated from enum value: REVOLVING_ACCOUNT_ADDED = 6;
     */
    REVOLVING_ACCOUNT_ADDED = 6,

    /**
     * @generated from enum value: INSTALLMENT_ACCOUNT_ADDED = 7;
     */
    INSTALLMENT_ACCOUNT_ADDED = 7,

    /**
     * @generated from enum value: REVOLVING_ACCOUNT_CLOSED = 8;
     */
    REVOLVING_ACCOUNT_CLOSED = 8,

    /**
     * @generated from enum value: INSTALLMENT_ACCOUNT_CLOSED = 9;
     */
    INSTALLMENT_ACCOUNT_CLOSED = 9,

    /**
     * @generated from enum value: ACCOUNT_REMOVED = 10;
     */
    ACCOUNT_REMOVED = 10,

    /**
     * @generated from enum value: HARD_INQUIRY = 11;
     */
    HARD_INQUIRY = 11,

    /**
     * @generated from enum value: HARD_INQUIRY_REMOVED = 12;
     */
    HARD_INQUIRY_REMOVED = 12,

    /**
     * @generated from enum value: CREDIT_LIMIT_INCREASE = 13;
     */
    CREDIT_LIMIT_INCREASE = 13,

    /**
     * @generated from enum value: CREDIT_LIMIT_DECREASE = 14;
     */
    CREDIT_LIMIT_DECREASE = 14,

    /**
     * @generated from enum value: DELINQUENT_ACCOUNT_REMOVED = 15;
     */
    DELINQUENT_ACCOUNT_REMOVED = 15,

    /**
     * @generated from enum value: OTHER_EVENTS = 16;
     */
    OTHER_EVENTS = 16,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CreditChangeItem.CreditChanges.CreditChangeDetails.EventType)
  proto3.util.setEnumType(CreditChangeItem.CreditChanges.CreditChangeDetails.EventType, "web.public.CreditChangeItem.CreditChanges.CreditChangeDetails.EventType", [
    { no: 0, name: "BALANCE_DECREASE" },
    { no: 1, name: "BALANCE_INCREASE" },
    { no: 2, name: "MISSED_PAYMENT" },
    { no: 3, name: "ON_TIME_PAYMENT" },
    { no: 4, name: "CHARGE_OFF" },
    { no: 5, name: "COLLECTION" },
    { no: 6, name: "REVOLVING_ACCOUNT_ADDED" },
    { no: 7, name: "INSTALLMENT_ACCOUNT_ADDED" },
    { no: 8, name: "REVOLVING_ACCOUNT_CLOSED" },
    { no: 9, name: "INSTALLMENT_ACCOUNT_CLOSED" },
    { no: 10, name: "ACCOUNT_REMOVED" },
    { no: 11, name: "HARD_INQUIRY" },
    { no: 12, name: "HARD_INQUIRY_REMOVED" },
    { no: 13, name: "CREDIT_LIMIT_INCREASE" },
    { no: 14, name: "CREDIT_LIMIT_DECREASE" },
    { no: 15, name: "DELINQUENT_ACCOUNT_REMOVED" },
    { no: 16, name: "OTHER_EVENTS" },
  ]);
}

export namespace CreditChangeItem.CreditChanges.CreditChangeDetails {
  /**
   * @generated from enum web.public.CreditChangeItem.CreditChanges.CreditChangeDetails.EventSubType
   */
  export enum EventSubType {
    /**
     * @generated from enum value: NONE = 0;
     */
    NONE = 0,

    /**
     * @generated from enum value: FORECLOSURE = 1;
     */
    FORECLOSURE = 1,

    /**
     * @generated from enum value: BANKRUPTCY = 2;
     */
    BANKRUPTCY = 2,

    /**
     * @generated from enum value: REPOSSESSION = 3;
     */
    REPOSSESSION = 3,

    /**
     * @generated from enum value: DEBT_SETTLEMENT = 4;
     */
    DEBT_SETTLEMENT = 4,

    /**
     * @generated from enum value: TAX_LIEN = 5;
     */
    TAX_LIEN = 5,

    /**
     * @generated from enum value: STUDENT_LOAN_DEFAULT = 6;
     */
    STUDENT_LOAN_DEFAULT = 6,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CreditChangeItem.CreditChanges.CreditChangeDetails.EventSubType)
  proto3.util.setEnumType(CreditChangeItem.CreditChanges.CreditChangeDetails.EventSubType, "web.public.CreditChangeItem.CreditChanges.CreditChangeDetails.EventSubType", [
    { no: 0, name: "NONE" },
    { no: 1, name: "FORECLOSURE" },
    { no: 2, name: "BANKRUPTCY" },
    { no: 3, name: "REPOSSESSION" },
    { no: 4, name: "DEBT_SETTLEMENT" },
    { no: 5, name: "TAX_LIEN" },
    { no: 6, name: "STUDENT_LOAN_DEFAULT" },
  ]);
}

export namespace CreditChangeItem.CreditChanges.CreditChangeDetails {
  /**
   * @generated from message web.public.CreditChangeItem.CreditChanges.CreditChangeDetails.Event
   */
  export class Event extends Message<CreditChangeItem.CreditChanges.CreditChangeDetails.Event> {
    /**
     * @generated from field: string id = 1;
     */
    id = "";

    /**
     * @generated from field: string account_name = 2;
     */
    accountName = "";

    /**
     * @generated from field: int32 amount_change_cents = 3;
     */
    amountChangeCents = 0;

    /**
     * @generated from field: int32 days_late = 4;
     */
    daysLate = 0;

    /**
     * @generated from field: web.public.CreditChangeItem.CreditChanges.CreditChangeDetails.EventSubType sub_type = 5;
     */
    subType = CreditChangeItem.CreditChanges.CreditChangeDetails.EventSubType.NONE;

    /**
     * @generated from field: google.protobuf.Timestamp reported_at = 6;
     */
    reportedAt?: Timestamp;

    /**
     * @generated from field: string contact_name = 7;
     */
    contactName = "";

    constructor(data?: PartialMessage<CreditChangeItem.CreditChanges.CreditChangeDetails.Event>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.CreditChangeItem.CreditChanges.CreditChangeDetails.Event";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "account_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 3, name: "amount_change_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
      { no: 4, name: "days_late", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
      { no: 5, name: "sub_type", kind: "enum", T: proto3.getEnumType(CreditChangeItem.CreditChanges.CreditChangeDetails.EventSubType) },
      { no: 6, name: "reported_at", kind: "message", T: Timestamp },
      { no: 7, name: "contact_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditChangeItem.CreditChanges.CreditChangeDetails.Event {
      return new CreditChangeItem.CreditChanges.CreditChangeDetails.Event().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditChangeItem.CreditChanges.CreditChangeDetails.Event {
      return new CreditChangeItem.CreditChanges.CreditChangeDetails.Event().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditChangeItem.CreditChanges.CreditChangeDetails.Event {
      return new CreditChangeItem.CreditChanges.CreditChangeDetails.Event().fromJsonString(jsonString, options);
    }

    static equals(a: CreditChangeItem.CreditChanges.CreditChangeDetails.Event | PlainMessage<CreditChangeItem.CreditChanges.CreditChangeDetails.Event> | undefined, b: CreditChangeItem.CreditChanges.CreditChangeDetails.Event | PlainMessage<CreditChangeItem.CreditChanges.CreditChangeDetails.Event> | undefined): boolean {
      return proto3.util.equals(CreditChangeItem.CreditChanges.CreditChangeDetails.Event, a, b);
    }

    static _enums: {
    };
  }
}

/**
 * @generated from message web.public.LiveAccount
 */
export class LiveAccount extends Message<LiveAccount> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: web.public.LiveAccount.Status status = 2;
   */
  status = LiveAccount.Status.NOT_LINKED;

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string last_four = 4;
   */
  lastFour = "";

  /**
   * @generated from field: string update_token = 5;
   */
  updateToken = "";

  /**
   * @generated from field: repeated web.public.LiveAccount.BalanceHistory balance_history = 6;
   */
  balanceHistory: LiveAccount.BalanceHistory[] = [];

  /**
   * @generated from field: repeated web.public.CreditBureau bureaus = 7;
   */
  bureaus: CreditBureau[] = [];

  constructor(data?: PartialMessage<LiveAccount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.LiveAccount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(LiveAccount.Status) },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last_four", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "update_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "balance_history", kind: "message", T: LiveAccount.BalanceHistory, repeated: true },
    { no: 7, name: "bureaus", kind: "enum", T: proto3.getEnumType(CreditBureau), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LiveAccount {
    return new LiveAccount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LiveAccount {
    return new LiveAccount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LiveAccount {
    return new LiveAccount().fromJsonString(jsonString, options);
  }

  static equals(a: LiveAccount | PlainMessage<LiveAccount> | undefined, b: LiveAccount | PlainMessage<LiveAccount> | undefined): boolean {
    return proto3.util.equals(LiveAccount, a, b);
  }

  static _enums: {
    Status: typeof LiveAccount.Status,
  };
}

export namespace LiveAccount {
  /**
   * @generated from enum web.public.LiveAccount.Status
   */
  export enum Status {
    /**
     * @generated from enum value: NOT_LINKED = 0;
     */
    NOT_LINKED = 0,

    /**
     * @generated from enum value: LINKED = 1;
     */
    LINKED = 1,

    /**
     * @generated from enum value: RELINK = 2;
     */
    RELINK = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(LiveAccount.Status)
  proto3.util.setEnumType(LiveAccount.Status, "web.public.LiveAccount.Status", [
    { no: 0, name: "NOT_LINKED" },
    { no: 1, name: "LINKED" },
    { no: 2, name: "RELINK" },
  ]);
}

export namespace LiveAccount {
  /**
   * @generated from message web.public.LiveAccount.BalanceHistory
   */
  export class BalanceHistory extends Message<LiveAccount.BalanceHistory> {
    /**
     * @generated from field: int32 balance_cents = 1;
     */
    balanceCents = 0;

    /**
     * @generated from field: int32 credit_limit_cents = 2;
     */
    creditLimitCents = 0;

    /**
     * @generated from field: google.protobuf.Timestamp checked_at = 3;
     */
    checkedAt?: Timestamp;

    constructor(data?: PartialMessage<LiveAccount.BalanceHistory>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.LiveAccount.BalanceHistory";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "balance_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
      { no: 2, name: "credit_limit_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
      { no: 3, name: "checked_at", kind: "message", T: Timestamp },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LiveAccount.BalanceHistory {
      return new LiveAccount.BalanceHistory().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LiveAccount.BalanceHistory {
      return new LiveAccount.BalanceHistory().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LiveAccount.BalanceHistory {
      return new LiveAccount.BalanceHistory().fromJsonString(jsonString, options);
    }

    static equals(a: LiveAccount.BalanceHistory | PlainMessage<LiveAccount.BalanceHistory> | undefined, b: LiveAccount.BalanceHistory | PlainMessage<LiveAccount.BalanceHistory> | undefined): boolean {
      return proto3.util.equals(LiveAccount.BalanceHistory, a, b);
    }

    static _enums: {
    };
  }
}

/**
 * @generated from message web.public.GetLiveCreditUtilizationRequest
 */
export class GetLiveCreditUtilizationRequest extends Message<GetLiveCreditUtilizationRequest> {
  constructor(data?: PartialMessage<GetLiveCreditUtilizationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetLiveCreditUtilizationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLiveCreditUtilizationRequest {
    return new GetLiveCreditUtilizationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLiveCreditUtilizationRequest {
    return new GetLiveCreditUtilizationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLiveCreditUtilizationRequest {
    return new GetLiveCreditUtilizationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLiveCreditUtilizationRequest | PlainMessage<GetLiveCreditUtilizationRequest> | undefined, b: GetLiveCreditUtilizationRequest | PlainMessage<GetLiveCreditUtilizationRequest> | undefined): boolean {
    return proto3.util.equals(GetLiveCreditUtilizationRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetLiveCreditUtilizationResponse
 */
export class GetLiveCreditUtilizationResponse extends Message<GetLiveCreditUtilizationResponse> {
  /**
   * @generated from field: web.public.GetLiveCreditUtilizationResponse.Status status = 1;
   */
  status = GetLiveCreditUtilizationResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated web.public.LiveAccount accounts = 3;
   */
  accounts: LiveAccount[] = [];

  constructor(data?: PartialMessage<GetLiveCreditUtilizationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetLiveCreditUtilizationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetLiveCreditUtilizationResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "accounts", kind: "message", T: LiveAccount, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLiveCreditUtilizationResponse {
    return new GetLiveCreditUtilizationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLiveCreditUtilizationResponse {
    return new GetLiveCreditUtilizationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLiveCreditUtilizationResponse {
    return new GetLiveCreditUtilizationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLiveCreditUtilizationResponse | PlainMessage<GetLiveCreditUtilizationResponse> | undefined, b: GetLiveCreditUtilizationResponse | PlainMessage<GetLiveCreditUtilizationResponse> | undefined): boolean {
    return proto3.util.equals(GetLiveCreditUtilizationResponse, a, b);
  }

  static _enums: {
    Status: typeof GetLiveCreditUtilizationResponse.Status,
  };
}

export namespace GetLiveCreditUtilizationResponse {
  /**
   * @generated from enum web.public.GetLiveCreditUtilizationResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: FAILED = 1;
     */
    FAILED = 1,

    /**
     * @generated from enum value: SUCCESS = 2;
     */
    SUCCESS = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetLiveCreditUtilizationResponse.Status)
  proto3.util.setEnumType(GetLiveCreditUtilizationResponse.Status, "web.public.GetLiveCreditUtilizationResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "FAILED" },
    { no: 2, name: "SUCCESS" },
  ]);
}

